<template>
  <div class="order-form-container">
    <el-container class="full-height">
      <!-- 添加滚动公告栏 -->
      <!-- <div class="announcement-bar" v-if="message">
        <el-alert
          :title="message"
          type="info"
          :closable="false"
          show-icon
          class="scrolling-text"
        >
        </el-alert>
      </div> -->
      <el-main>
        <!-- 表单部分 -->
        <el-form
          ref="orderForm"
          :model="order"
          :rules="rules"
          class="order-form"
        >
          <!-- 文件上传 -->
          <div class="upload-container" v-if="fileList.length === 0">
            <el-upload
              class="upload-demo"
              action=""
              :http-request="customUpload"
              :on-remove="handleRemove"
              :before-upload="beforeUpload"
              :file-list="fileList"
              :limit="1"
              :on-exceed="handleExceed"
              accept=".pdf"
              drag
            >
              <div class="upload-content">
                <img
                  src="../assets/pdf.png"
                  alt="上传PDF"
                  class="upload-icon"
                />
                <div class="upload-text">点击或拖拽文件到此处上传</div>
                <div class="el-upload__tip">
                  文档格式:仅支持非加密/只读类型的PDF文件
                </div>
              </div>
              <template #tip> </template>
            </el-upload>
          </div>

          <!-- 打印要求 - 仅在文件上传后显示 -->
          <template v-if="fileList.length > 0">
            <div class="section-header">
              <h2 style="font-size: 24px; font-weight: 600">文件打印设置</h2>
            </div>
            <el-form-item label=" 文件名称">
              <div class="file-name-display">
                <span class="file-name-text">{{ fileList[0].name }}</span>
                <el-button
                  type="primary"
                  size="small"
                  style="margin-left: 10px"
                  @click="reuploadFile"
                >
                  重新上传
                </el-button>
              </div>
            </el-form-item>
            <el-form-item label="打印颜色">
              <el-select v-model="order.printType" style="width: 100%">
                <el-option label="黑白" value="black"></el-option>
                <el-option label="彩色" value="color"></el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="打印面数">
              <el-select v-model="order.printSide" style="width: 100%">
                <el-option label="单面" value="单面"></el-option>
                <el-option label="双面" value="双面"></el-option>
                <el-option label="混合" value="混合"></el-option>
              </el-select>
            </el-form-item>

            <el-form-item
              label="翻页方式"
              v-if="order.printSide === '双面' || order.printSide === '混合'"
            >
              <el-select v-model="order.method" style="width: 100%">
                <el-option label="竖版左翻" value="竖版左翻" />
                <el-option label="竖版上翻" value="竖版上翻" />
                <el-option label="横版左翻" value="横版左翻" />
                <el-option label="横版上翻" value="横版上翻" />
              </el-select>
            </el-form-item>

            <el-form-item label="页面选择" v-if="order.printSide === '混合'">
              <el-button
                style="background-color: black; color: #fff"
                @click="openPageSelectorDialog"
              >
                选择单面打印页面
                <el-icon><Document /></el-icon>
              </el-button>
              <span
                v-if="selectedSingleSidePages.length > 0"
                style="margin-left: 10px; color: #67c23a"
              >
                已选择 {{ selectedSingleSidePages.length }} 页单面打印
              </span>
            </el-form-item>

            <el-form-item label="纸张大小">
              <el-select v-model="order.paperSize" style="width: 100%">
                <el-option label="A4" value="A4"></el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="纸张材质">
              <el-select v-model="order.paperMaterial" style="width: 100%">
                <el-option label="普通纸" value="普通纸" />
                <el-option
                  label="彩激纸"
                  value="彩激纸"
                  v-if="order.printType === 'color'"
                />
                <el-option
                  label="白卡纸"
                  value="白卡纸"
                  v-if="order.printType === 'color'"
                />
                <el-option
                  label="铜版纸"
                  value="铜版纸"
                  v-if="order.printType === 'color'"
                />
              </el-select>
            </el-form-item>

            <el-form-item label="纸张厚度">
              <el-select v-model="order.paperThickness" style="width: 100%">
                <el-option
                  label="80g"
                  value="80g"
                  v-if="order.paperMaterial === '普通纸'"
                />
                <el-option
                  label="100g"
                  value="100g"
                  v-if="order.paperMaterial === '彩激纸'"
                />
                <el-option
                  label="250g"
                  value="250g"
                  v-if="order.paperMaterial === '白卡纸'"
                />
                <el-option
                  label="300g"
                  value="300g"
                  v-if="order.paperMaterial === '白卡纸'"
                />
                <el-option
                  label="157g"
                  value="157g"
                  v-if="order.paperMaterial === '铜版纸'"
                />
                <el-option
                  label="200g"
                  value="200g"
                  v-if="order.paperMaterial === '铜版纸'"
                />
                <el-option
                  label="250g"
                  value="250g"
                  v-if="order.paperMaterial === '铜版纸'"
                />
                <el-option
                  label="300g"
                  value="300g"
                  v-if="order.paperMaterial === '铜版纸'"
                />
              </el-select>
            </el-form-item>

            <!-- <el-form-item label="缩印方式" >
              <el-select v-model="order.suoyin" style="width: 100%">
                <el-option label="不缩印" value="不缩印"></el-option>
                <el-option
                  label="二合一"
                  value="二合一"
                  @mouseenter="showMaterialPopover('二合一', $event)"
                  @mouseleave="hideMaterialPopover"
                />
                <el-option
                  label="四合一"
                  value="四合一"
                  @mouseenter="showMaterialPopover('四合一', $event)"
                  @mouseleave="hideMaterialPopover"
                />
                <el-option
                  label="六合一"
                  value="六合一"
                  @mouseenter="showMaterialPopover('六合一', $event)"
                  @mouseleave="hideMaterialPopover"
                />
              </el-select>
            </el-form-item> -->

            <el-form-item label="装订方式">
              <el-select v-model="order.bindingMethod">
                <el-option
                  v-for="item in bindingOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
            <el-form-item
              label="封面内容"
              v-if="
                order.bindingMethod === '胶装' ||
                order.bindingMethod === '骑马订'
              "
            >
              <el-select v-model="order.fm_content" style="width: 100%">
                <el-option label="空白封面" value="空白"></el-option>
                <el-option label="文件首页为封面" value="首页"></el-option>
                <el-option label="文件首尾为封面封底" value="首尾"></el-option>
              </el-select>
            </el-form-item>

            <el-form-item
              label="封面类型"
              v-if="
                order.bindingMethod === '胶装' ||
                order.bindingMethod === '骑马订'
              "
            >
              <el-select v-model="order.fm_type">
                <el-option
                  v-for="item in typeOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
                <!-- @mouseenter="showMaterialPopover(item.value, $event)"
                  @mouseleave="hideMaterialPopover" -->
              </el-select>
            </el-form-item>

            <!-- <el-form-item label="封面工艺" v-if="order.fm_content">
              <el-select v-model="order.fm_method" style="width: 100%">
                <el-option
                  label="无膜"
                  value="无膜"
                  v-if="order.fm_type === '铜版纸'"
                ></el-option>
                <el-option
                  label="亮膜"
                  value="亮膜"
                  v-if="order.fm_type === '铜版纸'"
                ></el-option>
                <el-option
                  label="哑膜"
                  value="哑膜"
                  v-if="order.fm_type === '铜版纸'"
                ></el-option>
                <el-option
                  label="白色"
                  value="白色"
                  v-if="order.fm_type === '皮纹纸'"
                ></el-option>
                <el-option
                  label="浅蓝"
                  value="浅蓝"
                  v-if="order.fm_type === '皮纹纸'"
                ></el-option>
                <el-option
                  label="湖蓝"
                  value="湖蓝"
                  v-if="order.fm_type === '皮纹纸'"
                ></el-option>
                <el-option
                  label="深蓝"
                  value="深蓝"
                  v-if="order.fm_type === '皮纹纸'"
                ></el-option>
                <el-option
                  label="米黄"
                  value="米黄"
                  v-if="order.fm_type === '皮纹纸'"
                ></el-option>
                <el-option
                  label="浅绿"
                  value="浅绿"
                  v-if="order.fm_type === '皮纹纸'"
                ></el-option>
                <el-option
                  label="粉红"
                  value="粉红"
                  v-if="order.fm_type === '皮纹纸'"
                ></el-option>
              </el-select>
            </el-form-item> -->

            <el-form-item label="打印份数">
              <el-input-number
                v-model="order.copies"
                :min="1"
                :max="100"
                :step="1"
                style="width: 180px"
              ></el-input-number>
            </el-form-item>

            <!-- <el-form-item label="配送时间" prop="deliveryTime">
              <el-date-picker
                v-model="order.deliveryTime"
                type="datetime"
                placeholder="选择配送时间"
                format="YYYY-MM-DD HH:mm:ss"
                value-format="YYYY-MM-DD HH:mm:ss"
                :default-time="new Date(2000, 1, 1, 12, 0, 0)"
                :disabled-date="disabledDate"
                :disabled-hours="disabledHours"
                :disabled-minutes="disabledMinutes"
                style="width: 100%"
              ></el-date-picker>
            </el-form-item> -->

            <!-- 提交按钮 -->
            <el-form-item>
              <div class="form-buttons">
                <el-button @click="openFilePreview">文件预览</el-button>
                <el-button type="primary" @click="submitOrder"
                  >完成设置</el-button
                >
              </div>
            </el-form-item>
          </template>
        </el-form>
      </el-main>
    </el-container>
    <!-- <div v-show="ImageDialogVisible" class="image-preview-wrapper">
      <div class="close-btn" @click="ImageDialogVisible = false">
        <el-icon><Close /></el-icon>
      </div>
      <img
        @click="ImageDialogVisible = false"
        src="https://www.xiaoliangtongxue.cn/api/sale-image"
        alt="暂无促销海报"
        class="preview-image"
      />
    </div> -->

    <!-- 混合打印页面选择对话框 -->
    <el-dialog
      title="混合打印页面选择"
      v-model="pageSelectorDialogVisible"
      width="80%"
      top="5vh"
      :before-close="handleClosePageSelector"
    >
      <div v-if="totalPages > 0" class="page-selector-container">
        <div class="page-selector-header">
          <span>选择需要单面打印的页面（共 {{ totalPages }} 页）：</span>
          <div class="page-selector-actions">
            <el-button size="small" @click="selectAllPages">全选</el-button>
            <el-button size="small" @click="clearAllSelections"
              >全不选</el-button
            >
          </div>
        </div>
        <div class="page-grid">
          <div
            v-for="page in visiblePages"
            :key="page"
            class="page-card"
            :class="{ selected: isPageSelected(page) }"
            @click="togglePageSelection(page)"
          >
            <div class="page-selector-number">{{ page }}</div>
            <div class="page-thumb" ref="pageThumbs">
              <canvas :id="'page-' + page"></canvas>
            </div>
          </div>
        </div>
        <div class="page-selector-footer">
          <span>已选择 {{ selectedSingleSidePages.length }} 页单面打印</span>
          <span>其余页面双面打印</span>
        </div>
      </div>
      <div v-else class="no-pages-message">
        <p>请先上传PDF文件以查看页面缩略图</p>
      </div>
      <template #footer>
        <div class="dialog-footer">
          <el-button @click="handleClosePageSelector">取消</el-button>
          <el-button type="primary" @click="confirmPageSelection"
            >确定</el-button
          >
        </div>
      </template>
    </el-dialog>

    <!-- 纸张材质浮窗 -->
    <div
      v-if="popoverVisible && hoveredMaterial"
      class="material-popover"
      :style="{
        left: popoverPosition.x + 'px',
        top: popoverPosition.y + 'px',
      }"
    >
      <img
        :src="materialDetails[hoveredMaterial].image"
        class="popover-image"
      />
      <div class="popover-content">
        <h3>{{ hoveredMaterial }}</h3>
        <p>{{ materialDetails[hoveredMaterial].description }}</p>
      </div>
    </div>

    <!-- 文件预览弹窗 -->
    <el-dialog
      title="文件预览"
      :model-value="previewDialogVisible"
      @update:model-value="(val) => (previewDialogVisible = val)"
      width="70%"
      top="5vh"
    >
      <div class="confirm-dialog-content">
        <!-- 左侧：翻书效果预览 -->
        <div class="preview-section book-preview-section">
          <h3>打印效果预览</h3>
          <div class="book-preview-container">
            <div class="book-stage" ref="bookStage">
              <div class="book" ref="book">
                <!-- 左页（静态） -->
                <div class="page left-static" ref="leftPage">
                  <div class="page-content" ref="leftContent"></div>
                  <div class="page-number left-num" ref="leftNum"></div>
                </div>
                <!-- 右页（动态） -->
                <div class="page right-dynamic" ref="rightPage">
                  <div class="page-content" ref="rightContent"></div>
                  <div class="page-number right-num" ref="rightNum"></div>
                </div>
              </div>
            </div>
            <!-- 翻页控制 -->
            <div class="book-controls">
              <el-button
                size="small"
                @click="goPrevPage"
                :disabled="currentSheetIndex <= -1"
                icon="ArrowLeft"
              >
                上一页
              </el-button>
              <span class="page-indicator">{{ getPageIndicator() }}</span>
              <el-button
                size="small"
                @click="goNextPage"
                :disabled="currentSheetIndex >= physicalSheets.length - 1"
                icon="ArrowRight"
              >
                下一页
              </el-button>
            </div>
          </div>
        </div>
      </div>

      <template #footer>
        <span class="dialog-footer">
          <el-button @click="previewDialogVisible = false">关闭</el-button>
        </span>
      </template>
    </el-dialog>

    <!-- 订单确认弹窗 -->
    <el-dialog
      :model-value="confirmDialogVisible"
      @update:model-value="(val) => (confirmDialogVisible = val)"
      width="70%"
      top="0vh"
    >
      <div class="confirm-dialog-content">
        <!-- 左侧：配送信息和费用计算 -->
        <div class="left-panel">
          <!-- 配送信息 -->
          <div class="delivery-info">
            <h3>配送信息</h3>
            <el-form :model="order" label-width="80px">
              <el-form-item label="姓名">
                <el-input
                  v-model="order.name"
                  placeholder="请输入姓名"
                ></el-input>
              </el-form-item>

              <el-form-item label="手机号">
                <el-input
                  v-model="order.phone"
                  placeholder="请输入手机号"
                ></el-input>
              </el-form-item>

              <el-form-item label="配送方式">
                <el-radio-group
                  v-model="order.deliveryMethod"
                  @change="handleDeliveryMethodChange"
                >
                  <el-radio label="配送">配送</el-radio>
                  <el-radio label="校外自取">校外自取</el-radio>
                  <!-- <el-radio
                    label="校内自取"
                    v-if="order.bindingMethod === '无装订'"
                    >校内自取</el-radio
                  > -->
                </el-radio-group>
              </el-form-item>

              <el-form-item
                label="自取地址"
                v-if="order.deliveryMethod === '校外自取'"
              >
                上海市宝山区沪太路4290号1876新视觉文创园5号楼301室
              </el-form-item>

              <el-form-item
                label="自取地址"
                v-if="order.deliveryMethod === '校内自取'"
              >
                上海大学宝山校区C楼爱心屋（仅限无装订，优惠券订单）
              </el-form-item>

              <el-form-item
                label="配送地点"
                prop="deliveryAddress"
                v-if="order.deliveryMethod === '配送'"
              >
                <div style="display: flex; align-items: center; gap: 10px">
                  <span>上海大学宝山校区</span>
                  <el-select
                    v-model="order.deliveryAddress"
                    placeholder="选择历史地址或输入新地址"
                    filterable
                    allow-create
                    default-first-option
                    style="flex: 1"
                  >
                    <el-option
                      v-for="addr in historyAddresses"
                      :key="addr.address"
                      :label="addr.address"
                      :value="addr.address"
                    >
                      <div class="address-option">
                        <span class="address-text">{{ addr.address }}</span>
                      </div>
                    </el-option>
                  </el-select>
                </div>
              </el-form-item>

              <el-form-item label="备注">
                <el-input
                  v-model="order.note"
                  placeholder="请输入备注"
                  type="textarea"
                  :rows="2"
                ></el-input>
              </el-form-item>
            </el-form>
          </div>

          <!-- 费用计算 -->
          <div class="price-calculation">
            <h3>费用计算</h3>
            <div class="price-details">
              <div class="price-item">
                <span>单价：</span>
                <span v-if="order.printSide == '单面'"
                  >¥
                  {{ (calculatedPrice.unitPrice || 0).toFixed(2) }} 元/张</span
                >
                <span v-else
                  >¥
                  {{ (calculatedPrice.unitPrice || 0).toFixed(2) }} 元/面</span
                >
              </div>
              <div class="price-item">
                <span>面数：</span>
                <span>{{ calculatedPageCount }} 面</span>
              </div>
              <div class="price-item">
                <span>份数：</span>
                <span>{{ order.copies }} 份</span>
              </div>

              <div class="price-divider"></div>
              <div class="price-item">
                <span>打印费用：</span>
                <span
                  >¥
                  {{
                    (
                      calculatedPrice.basePrice -
                      calculatedPrice.bindingPrice -
                      (coverPrice || 0)
                    ).toFixed(2)
                  }}</span
                >
              </div>
              <div class="price-item" v-if="calculatedPrice.bindingPrice > 0">
                <span>装订费用：</span>
                <span
                  >¥ {{ (calculatedPrice.bindingPrice || 0).toFixed(2) }}</span
                >
              </div>
              <div class="price-item" v-if="coverPrice > 0">
                <span>封面费用：</span>
                <span>¥ {{ (coverPrice || 0).toFixed(2) }}</span>
              </div>
              <div class="price-item">
                <span>原价总计：</span>
                <span>¥ {{ (calculatedPrice.basePrice || 0).toFixed(2) }}</span>
              </div>
              <div class="price-item" v-if="calculatedPrice.discountAmount > 0">
                <span>折扣：</span>
                <span class="discount-amount">
                  {{ order.deliveryMethod === "校外自取" ? "7折" : "5折" }}
                </span>
              </div>
              <div
                class="price-item"
                v-if="
                  !hasOrders &&
                  !(!hasInnerOrders && order.deliveryMethod === '校内自取')
                "
              >
                <el-checkbox v-model="useCoupon" @change="recalculatePrice">
                  使用新人优惠券（立减5元）
                </el-checkbox>
              </div>
              <div
                class="price-item"
                v-if="!hasInnerOrders && order.deliveryMethod === '校内自取'"
              >
                <el-checkbox
                  v-model="useInnerCoupon"
                  @change="recalculatePrice"
                >
                  使用爱心屋专享优惠券（立减5元）
                </el-checkbox>
              </div>
              <!-- <div class="price-item" v-if="calculatedPrice.discountAmount > 0">
                <span>优惠金额：</span>
                <span class="discount-amount"
                  >-¥
                  {{ (calculatedPrice.discountAmount || 0).toFixed(2) }}</span
                >
              </div> -->
              <div class="price-divider"></div>
              <div class="price-total">
                <span>实付金额：</span>
                <span
                  >¥ {{ (calculatedPrice.totalPrice || 0).toFixed(2) }}</span
                >
                <span v-if="!hasOrders" style="color: #67c23a"
                  >（新人优惠）</span
                >
              </div>
            </div>
          </div>
        </div>

        <!-- 右侧：打印要求 -->
        <div class="right-panel">
          <h3>订单信息</h3>
          <el-descriptions :column="1" border>
            <el-descriptions-item label="文件名称">{{
              fileList.length > 0 ? fileList[0].name : "无"
            }}</el-descriptions-item>
            <el-descriptions-item label="打印类型">
              {{
                order.printType === "black" ? "黑白" : "彩色"
              }} </el-descriptions-item
            ><el-descriptions-item label="打印面数">
              {{ order.printSide }}
              <span
                v-if="order.printSide === '混合'"
                style="color: #67c23a; margin-left: 8px"
              >
                ({{ selectedSingleSidePages.length }}页单面)
              </span>
            </el-descriptions-item>
            <el-descriptions-item
              label="翻页方式"
              v-if="order.printSide === '双面'"
            >
              {{ order.method }}
            </el-descriptions-item>

            <el-descriptions-item label="纸张大小">
              {{ order.paperSize }}
            </el-descriptions-item>
            <el-descriptions-item label="纸张材质">
              {{ order.paperMaterial || "未选择" }}
            </el-descriptions-item>
            <el-descriptions-item label="纸张厚度">
              {{ order.paperThickness || "未选择" }}
            </el-descriptions-item>
            <el-descriptions-item label="装订方式">
              {{ order.bindingMethod }}
            </el-descriptions-item>
            <el-descriptions-item label="封面内容">
              {{
                order.fm_content
                  ? order.fm_content === "空白"
                    ? "空白封面"
                    : order.fm_content === "首页"
                    ? "文件首页为封面"
                    : "文件首尾为封面封底"
                  : "不添加封面"
              }}
            </el-descriptions-item>
            <el-descriptions-item label="封面类型" v-if="order.fm_content">
              {{ order.fm_type }}
            </el-descriptions-item>
            <!-- <el-descriptions-item label="封面工艺" v-if="order.fm_content">
              {{ order.fm_method }}
            </el-descriptions-item> -->
            <el-descriptions-item label="打印份数">
              {{ order.copies }} 份
            </el-descriptions-item>
          </el-descriptions>
          <div class="right-panel-buttons">
            <el-button @click="confirmDialogVisible = false">取消</el-button>
            <el-button type="warning" @click="goon">加入购物车</el-button>
            <el-button type="primary" @click="confirmOrder">立即支付</el-button>
          </div>
        </div>
      </div>
    </el-dialog>
    <!-- 支付二维码弹窗 -->
    <el-dialog
      title="订单支付"
      :model-value="paymentDialogVisible"
      @update:model-value="(val) => (paymentDialogVisible = val)"
      width="400px"
      center
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
    >
      <div class="payment-dialog-content">
        <div class="order-info">
          <p class="order-number">订单号：{{ order_id }}</p>
          <p class="order-amount">
            支付金额：¥ {{ (calculatedPrice.totalPrice || 0).toFixed(2) }}
          </p>
        </div>
        <div class="qr-code-container">
          <img
            :src="qrCodeUrl"
            class="qr-code-image"
            alt="扫码支付"
            v-if="qrCodeUrl"
          />
          <div class="qr-code-loading" v-else>
            <el-icon class="is-loading"><loading /></el-icon>
            <span>正在生成支付二维码...</span>
          </div>
        </div>
        <div class="payment-tips">
          <p>请使用微信扫描二维码完成支付</p>
          <p class="expire-time" v-if="expireTime">
            支付倒计时：{{ expireTime }}
          </p>
        </div>
      </div>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="cancelPayment">取消支付</el-button>
        </span>
      </template>
    </el-dialog>
  </div>
</template>
  
<script>
import axios from "axios";
import { Document } from "@element-plus/icons-vue";

export default {
  name: "CreateOrder",
  components: {
    Document,
  },
  data() {
    return {
      ImageDialogVisible: true,
      poor: false,
      on: false,
      useCoupon: false,
      useInnerCoupon: false,
      rules: {
        // deliveryTime: [
        //   { required: true, message: "请选择配送时间", trigger: "change" },
        // ],
      },
      message: "",
      order: {
        printType: "",
        printSide: "",
        paperSize: "",
        paperMaterial: "",
        paperThickness: "",
        copies: 1,
        name: "",
        phone: "",
        deliveryMethod: "配送",
        deliveryAddress: "",
        deliveryTime: "",
        selectedCoupon: null,
        bindingMethod: "",
        method: "竖版左翻",
        fm_content: "",
        fm_type: "",
        fm_method: "",
        suoyin: "",
        note: "",
      },
      selectedSingleSidePages: [],
      visiblePages: [],
      totalPages: 0,
      selectedFile: null,
      mixedPrintProcessed: false, // 标记混合打印文件是否已处理（添加了空白页）
      materials: ["普通纸", "铜版纸"],
      hasOrders: false,
      hasInnerOrders: false,
      typeOptions: [
        {
          value: "铜版纸-无膜",
          label: "铜版纸-无膜",
        },
        {
          value: "铜版纸-哑膜",
          label: "铜版纸-哑膜",
        },
        {
          value: "铜版纸-亮膜",
          label: "铜版纸-亮膜",
        },
        {
          value: "皮纹纸-浅蓝",
          label: "皮纹纸-浅蓝",
        },
        {
          value: "皮纹纸-湖蓝",
          label: "皮纹纸-湖蓝",
        },
        {
          value: "皮纹纸-浅绿",
          label: "皮纹纸-浅绿",
        },
        {
          value: "皮纹纸-浅黄",
          label: "皮纹纸-浅黄",
        },
        {
          value: "皮纹纸-白色",
          label: "皮纹纸-白色",
        },
      ],
      bindingOptions: [
        {
          value: "无装订",
          label: "无装订",
        },
        {
          value: "订书钉（左侧双钉）",
          label: "订书钉（左侧双钉）",
        },
        {
          value: "订书钉（左上一钉）",
          label: "订书钉（左上一钉）",
        },
        {
          value: "胶装",
          label: "胶装",
        },
        {
          value: "骑马订",
          label: "骑马订",
        },
      ],
      printTypeOptions: [
        {
          value: "black",
          label: "黑白",
        },
        {
          value: "color",
          label: "彩色",
        },
      ],
      printSideOptions: [
        {
          value: "单面",
          label: "单面",
        },
        {
          value: "双面",
          label: "双面",
        },
        {
          value: "混合",
          label: "混合",
        },
      ],
      methodOptions: [
        {
          value: "竖版左翻",
          label: "竖版左翻",
        },
        {
          value: "竖版上翻",
          label: "竖版上翻",
        },
        {
          value: "横版左翻",
          label: "横版左翻",
        },
        {
          value: "横版上翻",
          label: "横版上翻",
        },
      ],
      paperSizeOptions: [
        {
          value: "A4",
          label: "A4",
        },
      ],
      paperMaterialOptions: [
        {
          value: "普通纸",
          label: "普通纸",
        },
      ],

      suoyinOptions: [
        {
          value: "不缩印",
          label: "不缩印",
        },
        {
          value: "二合一",
          label: "二合一",
        },
        {
          value: "四合一",
          label: "四合一",
        },
        {
          value: "六合一",
          label: "六合一",
        },
      ],
      fmContentOptions: [
        {
          value: "",
          label: "不添加封面",
        },
        {
          value: "空白",
          label: "空白封面",
        },
        {
          value: "首页",
          label: "文件首页为封面",
        },
        {
          value: "首尾",
          label: "文件首尾为封面封底",
        },
      ],
      fmMethodOptions: [
        {
          value: "无膜",
          label: "无膜",
        },
        {
          value: "覆膜",
          label: "覆膜",
        },
      ],
      materialDetails: {
        普通纸: {
          description: "标准打印用纸，适合日常文档打印",
          image: require("../assets/普通纸.jpg"),
        },
        铜版纸: {
          description: "表面光滑，色彩鲜艳，适合高质量图片打印",
          image: require("../assets/铜版纸.jpg"),
        },
        不干胶: {
          description: "面纸带胶100克/㎡",
          image: require("../assets/图片14.png"),
        },
        竖版左翻: {
          description: "",
          image: require("../assets/2.jpg"),
        },
        竖版上翻: {
          description: "",
          image: require("../assets/1.jpg"),
        },
        横版左翻: {
          description: "",
          image: require("../assets/3.jpg"),
        },
        横版上翻: {
          description: "",
          image: require("../assets/4.jpg"),
        },
        无装订: {
          description: "",
          image: require("../assets/图片 2.png"),
        },
        订书钉: {
          description: "",
          image: require("../assets/订书钉.jpg"),
        },
        骑马订: {
          description: "骑马订页数必须是4的倍数",
          image: require("../assets/图片 3.png"),
        },
        胶装: {
          description: "推荐10-200张",
          image: require("../assets/图片 1.png"),
        },
        "皮纹纸-浅蓝": {
          description: "",
          image: require("../assets/色卡/2.jpg"),
        },
        "皮纹纸-湖蓝": {
          description: "",
          image: require("../assets/色卡/3.jpg"),
        },
        "皮纹纸-浅绿": {
          description: "",
          image: require("../assets/色卡/4.jpg"),
        },
        "皮纹纸-浅黄": {
          description: "",
          image: require("../assets/色卡/5.jpg"),
        },
        "皮纹纸-白色": {
          description: "",
          image: require("../assets/色卡/6.jpg"),
        },
        二合一: {
          description: "",
          image: require("../assets/图片 8.png"),
        },
        四合一: {
          description: "",
          image: require("../assets/图片 9.png"),
        },
        六合一: {
          description: "",
          image: require("../assets/图片 10.png"),
        },
      },
      hoveredMaterial: null,
      popoverVisible: false,
      popoverPosition: { x: 0, y: 0 },
      fileList: [],
      priceData: [
        {
          size: "A4",
          prices: [
            // 黑白打印 - 双胶纸 80g
            {
              type: "黑白",
              material: "普通纸",
              thickness: "80g",
              singleSide: 1, // 零散类 1-20P
              doubleSide: 0.5,
            },
            {
              type: "黑白",
              material: "普通纸",
              thickness: "80g",
              singleSide: 0.3, // 批量类 20P以上
              doubleSide: 0.2,
            }, // 彩色打印
            {
              type: "彩色",
              material: "普通纸",
              thickness: "80g",
              singleSide: 1,
              doubleSide: 0.8,
            },
            {
              type: "彩色",
              material: "彩激纸",
              thickness: "100g",
              singleSide: 1.2,
              doubleSide: 1,
            },
            {
              type: "彩色",
              material: "铜版纸",
              thickness: "157g",
              singleSide: 1.5,
              doubleSide: 1.2,
            },
            {
              type: "彩色",
              material: "铜版纸",
              thickness: "200g",
              singleSide: 2,
              doubleSide: 1.5,
            },
            {
              type: "彩色",
              material: "铜版纸",
              thickness: "250g",
              singleSide: 2.5,
              doubleSide: 2,
            },
            {
              type: "彩色",
              material: "铜版纸",
              thickness: "300g",
              singleSide: 3,
              doubleSide: 2.5,
            },
            {
              type: "彩色",
              material: "白卡纸",
              thickness: "250g",
              singleSide: 2.5,
              doubleSide: 2.5,
            },
            {
              type: "彩色",
              material: "白卡纸",
              thickness: "300g",
              singleSide: 3,
              doubleSide: 3,
            },
          ],
        },
      ],
      confirmDialogVisible: false,
      previewDialogVisible: false,
      calculatedPrice: {
        basePrice: 0,
        totalPrice: 0,
        unitPrice: 0,
        discountAmount: 0, // 添加优惠金额字段
        bindingPrice: 0, // 添加装订费用字段
      },
      availableCoupons: [], // 添加可用优惠券列表
      calculatedPageCount: 0,
      filePages: {},
      pdfjsLib: null, // 添加 pdfjsLib 变量
      userId: localStorage.getItem("userId"), // 添加用户ID
      paymentDialogVisible: false,
      qrCodeUrl: "",
      orderNumber: "",
      order_id: "",
      paymentTimer: null,
      expireTime: "",
      paymentCheckInterval: null,
      historyAddresses: [], // 添加历史地址数组
      newAddress: "", // 添加新地址输入框的值
      craftGuideVisible: false, // 新增工艺说明弹窗
      pageSelectorDialogVisible: false, // 混合打印页面选择对话框
      // 翻书效果相关数据
      physicalSheets: [], // 物理纸张数组
      currentSheetIndex: -1, // 当前显示的纸张索引
      isAnimating: false, // 是否正在翻页动画中
      nIn1: 1, // 缩印倍数
      isLandscape: false, // 是否横向
      bindingPriceData: [
        {
          type: "无装订",
          price: "免费",
          notes: "无需装订",
        },
        {
          type: "订书钉",
          price: "免费",
          notes: "适合薄本，限1-100张",
        },
        {
          type: "骑马订",
          price: 3,
          notes: "页码必须4的倍数，推荐36面以内",
        },
        {
          type: "胶装",
          price: "10元/本",
          notes: "推荐10-200张",
        },
      ],
      coverPriceData: [
        {
          type: "皮纹纸",
          price: 2,
          notes: "220g皮纹纸，有纹路，厚度27丝左右",
        },
        {
          type: "铜版纸",
          price: 3,
          notes: "250g铜版纸，厚度23丝左右",
        },
        {
          type: "铜版纸覆膜",
          price: 5,
          notes: "250g铜版纸+覆膜，更耐用美观",
        },
      ],
      coverPrice: 0,
    };
  },
  // 移除 computed 属性中的选项限制
  computed: {
    // 如果有其他计算属性保留在这里
  },
  // 添加 watch 监听器
  watch: {
    "order.printSide"(newVal, oldVal) {
      if (newVal === "混合" && this.fileList.length > 0) {
        // 切换到混合模式，初始化页面选择器
        this.mixedPrintProcessed = false; // 重置处理标志
        const file = this.fileList[0];
        if (file) {
          const pageCount = this.filePages[file.uid];
          if (pageCount) {
            this.selectedFile = file;
            this.totalPages = pageCount;
            this.visiblePages = Array.from(
              { length: pageCount },
              (_, i) => i + 1
            );
            this.selectedSingleSidePages = []; // 初始化为空数组
            this.$nextTick(() => {
              this.renderAllPageThumbnails();
            });
          }
        }
      } else if (oldVal === "混合" && newVal !== "混合") {
        // 从混合模式切换出去，清理数据
        this.selectedFile = null;
        this.totalPages = 0;
        this.visiblePages = [];
        this.selectedSingleSidePages = [];
        this.mixedPrintProcessed = false; // 重置处理标志
      }
    },
    "order.paperMaterial"(newVal) {
      if (newVal) {
        this.order.paperThickness = "";
      }
    },
    "order.bindingMethod"(newVal, oldVal) {
      const hasCoverOld = oldVal === "胶装" || oldVal === "骑马订";
      const hasCoverNew = newVal === "胶装" || newVal === "骑马订";
      if (hasCoverOld && !hasCoverNew) {
        this.order.fm_content = "";
        this.order.fm_type = "";
      }
    },
    "order.printType"(newVal) {
      if (newVal === "black") {
        this.order.paperMaterial = "普通纸";
        this.order.paperThickness = "";
      }
    },
  },
  async created() {
    // 从 localStorage 获取用户信息
    this.userId = localStorage.getItem("userId");
    this.order.name = localStorage.getItem("userName") || "";
    this.order.phone = localStorage.getItem("userPhone") || "";
    if (this.userId == "admin") {
      this.order.name = "admin";
      this.order.phone = "00000000000";
      this.userId = 6;
    }
    this.getpoor();
    this.fetchMessage();
    this.fetchAvailableCoupons();
    this.fetchHasOrders();
    this.fetchHistoryAddresses(); // 添加获取历史地址的调用
    try {
      await this.initPdfLib();
    } catch (error) {
      console.error("PDF.js 初始化失败:", error);
      this.$message.error("PDF处理组件加载失败，可能影响文件页数统计");
    }
    this.fetchSaleImage();
  },
  methods: {
    handleDeliveryMethodChange(value) {
      if (value === "校外自取") {
        this.order.deliveryAddress = "校外自取";
      } else if (value === "校内自取") {
        this.order.deliveryAddress = "校内自取";
      } else if (value === "配送") {
        this.order.deliveryAddress = "";
      }
      this.calculatePrice();
    },
    async fetchSaleImage() {
      const response = await fetch(
        "https://www.xiaoliangtongxue.cn/api/sale-image",
        { credentials: "include" }
      );
      try {
        const data = await response.json();
        this.ImageDialogVisible = data.success;
        // 成功解析，是JSON
      } catch (e) {
        // 解析失败，不是JSON
        console.log("Not a JSON response");
      }
    },
    handleCloseImageDialog() {
      this.ImageDialogVisible = false;
    },
    getpoor() {
      axios
        .get(`https://www.xiaoliangtongxue.cn/api/user/${this.userId}/poor`, {
          withCredentials: true,
        })
        .then((response) => {
          this.poor = response.data.data;
        });
    },
    goon() {
      if (!this.order.deliveryAddress) {
        this.$message.warning("请选择配送地址");
        return;
      }
      this.on = true;
      this.submit();
      this.$message({
        message: "加入购物车成功，请在十五分钟内完成支付！",
        type: "success",
      });
    },
    async fetchMessage() {
      try {
        const response = await fetch(
          "https://www.xiaoliangtongxue.cn/api/message",
          {
            method: "GET",
            credentials: "include",
          }
        );

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const data = await response.json();
        if (data.success) {
          this.message = data.content;
        } else {
          console.error("Failed to get message:", data.content);
          this.message = "Default message";
        }
      } catch (error) {
        console.error("Error fetching message:", error);
        this.message = "Failed to load message";
      }
    },
    customUpload(options) {
      // 创建符合预期格式的文件对象
      const file = {
        raw: options.file,
        uid: Date.now(),
        name: options.file.name,
        size: options.file.size,
        type: options.file.type,
      };

      // 调用 handleFileChange，传入正确格式的文件对象
      this.handleFileChange(file, [...this.fileList, file]);
      return false;
    },

    // 添加初始化 PDF.js 的方法
    async initPdfLib() {
      if (window.pdfjsLib) {
        this.pdfjsLib = window.pdfjsLib;
        return;
      }

      return new Promise((resolve, reject) => {
        const script = document.createElement("script");
        script.src =
          "https://cdnjs.cloudflare.com/ajax/libs/pdf.js/3.11.174/pdf.min.js";
        script.onload = () => {
          const workerScript = document.createElement("script");
          workerScript.src =
            "https://cdnjs.cloudflare.com/ajax/libs/pdf.js/3.11.174/pdf.worker.min.js";
          workerScript.onload = () => {
            window.pdfjsLib.GlobalWorkerOptions.workerSrc = workerScript.src;
            this.pdfjsLib = window.pdfjsLib;
            resolve();
          };
          workerScript.onerror = reject;
          document.head.appendChild(workerScript);
        };
        script.onerror = reject;
        document.head.appendChild(script);
      });
    },

    // 修改获取PDF页数的方法
    async getPdfPageCount(file) {
      if (!this.pdfjsLib) {
        await this.initPdfLib();
      }

      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = async (event) => {
          const typedarray = new Uint8Array(event.target.result);
          try {
            const pdf = await this.pdfjsLib.getDocument({ data: typedarray })
              .promise;
            resolve(pdf.numPages);
          } catch (error) {
            console.error("获取PDF页数失败:", error);
            reject(error);
          }
        };
        reader.onerror = reject;
        reader.readAsArrayBuffer(file.raw);
      });
    },

    // 修改文件上传处理方法
    async handleFileChange(file, fileList) {
      if (!file || !file.raw) {
        console.error("Invalid file object:", file);
        return;
      }

      this.fileList = fileList;

      try {
        const pageCount = await this.getPdfPageCount(file);
        // 使用直接赋值替代 $set
        this.filePages[file.uid] = pageCount;
        await this.createPdfPreview(file);

        // 设置混合打印相关数据
        if (this.order.printSide === "混合") {
          this.mixedPrintProcessed = false; // 重置处理标志
          this.selectedFile = file;
          this.totalPages = pageCount;
          this.visiblePages = Array.from(
            { length: pageCount },
            (_, i) => i + 1
          );
          this.selectedSingleSidePages = []; // 初始化为空数组
          this.$nextTick(() => {
            this.renderAllPageThumbnails();
          });
        }
      } catch (error) {
        console.error("处理文件失败:", error);
        this.$message.error("获取文件页数失败，请重试");
        // 如果处理失败，从文件列表中移除该文件
        this.fileList = this.fileList.filter((f) => f.uid !== file.uid);
      }
    },

    // 修改文件移除方法
    handleRemove(file) {
      // 使用 delete 操作符替代 $delete
      delete this.filePages[file.uid];
      // 更新文件列表
      this.fileList = this.fileList.filter((f) => f.uid !== file.uid);
      // 释放预览 URL
      if (file.url) {
        URL.revokeObjectURL(file.url);
      }
      // 清理混合打印相关数据
      if (this.order.printSide === "混合" && this.fileList.length === 0) {
        this.selectedFile = null;
        this.totalPages = 0;
        this.visiblePages = [];
        this.selectedSingleSidePages = [];
        this.mixedPrintProcessed = false; // 重置处理标志
      }
    },

    // 重新上传文件方法
    reuploadFile() {
      const file = this.fileList[0];
      if (file) {
        delete this.filePages[file.uid];
        if (file.url) {
          URL.revokeObjectURL(file.url);
        }
      }
      this.fileList = [];
      this.selectedFile = null;
      this.totalPages = 0;
      this.visiblePages = [];
      this.selectedSingleSidePages = [];
      this.mixedPrintProcessed = false;
      this.order.printSide = "";
      this.order.printType = "";
      this.order.paperSize = "";
      this.order.paperMaterial = "";
      this.order.paperThickness = "";
      this.order.bindingMethod = "";
      this.order.method = "竖版左翻";
      this.order.fm_content = "";
      this.order.fm_type = "";
      this.order.copies = 1;
    },

    // 混合打印相关方法
    isPageSelected(page) {
      return this.selectedSingleSidePages.includes(page);
    },

    togglePageSelection(page) {
      const index = this.selectedSingleSidePages.indexOf(page);
      if (index > -1) {
        this.selectedSingleSidePages.splice(index, 1);
      } else {
        this.selectedSingleSidePages.push(page);
      }
    },

    selectAllPages() {
      this.selectedSingleSidePages = [...this.visiblePages];
    },

    clearAllSelections() {
      this.selectedSingleSidePages = [];
    },

    async renderAllPageThumbnails() {
      if (!this.selectedFile || !this.pdfjsLib) {
        return;
      }

      const pageCount = this.filePages[this.selectedFile.uid];
      for (let i = 1; i <= pageCount; i++) {
        await this.renderPageThumbnail(i);
      }
    },

    async renderPageThumbnail(pageNum) {
      if (!this.selectedFile || !this.pdfjsLib) {
        return;
      }

      const reader = new FileReader();
      reader.onload = async (event) => {
        const typedarray = new Uint8Array(event.target.result);
        try {
          const pdf = await this.pdfjsLib.getDocument({ data: typedarray })
            .promise;
          const page = await pdf.getPage(pageNum);

          const canvas = document.getElementById(`page-${pageNum}`);
          if (!canvas) return;

          const container = canvas.parentElement;
          const containerWidth = container.clientWidth;
          const containerHeight = container.clientHeight;

          if (containerWidth === 0 || containerHeight === 0) return;

          const viewportRaw = page.getViewport({ scale: 1 });
          const scaleX = containerWidth / viewportRaw.width;
          const scaleY = containerHeight / viewportRaw.height;
          const scale = Math.min(scaleX, scaleY);

          const viewport = page.getViewport({ scale });
          const context = canvas.getContext("2d");
          canvas.height = viewport.height;
          canvas.width = viewport.width;

          await page.render({
            canvasContext: context,
            viewport: viewport,
          }).promise;
        } catch (error) {
          console.error(`渲染第 ${pageNum} 页缩略图失败:`, error);
        }
      };
      reader.readAsArrayBuffer(this.selectedFile.raw);
    },

    createPdfPreview(file) {
      return new Promise((resolve, reject) => {
        if (!file || !file.raw) {
          console.error("Invalid file object:", file);
          reject(new Error("Invalid file object"));
          return;
        }

        try {
          // 确保 file.raw 是有效的 File 对象
          if (file.raw instanceof File) {
            const url = URL.createObjectURL(file.raw);
            file.url = url;
            resolve();
          } else {
            const error = new Error("Invalid file object: not a File instance");
            console.error(error);
            reject(error);
          }
        } catch (error) {
          console.error("Create preview error:", error);
          reject(error);
        }
      });
    },

    beforeUpload(file) {
      const isPDF = file.type === "application/pdf";
      if (!isPDF) {
        this.$message.error("只能上传 PDF 文件！");
      }
      return isPDF;
    },
    // 修改价格计算方法
    async calculatePrice() {
      // 计算总页数（PDF实际页数）
      const totalPdfPages = Object.values(this.filePages).reduce(
        (sum, pages) => sum + pages,
        0
      );

      // 获取缩印倍数
      let shrinkRatio = 1;
      switch (this.order.suoyin) {
        case "二合一":
          shrinkRatio = 2;
          break;
        case "四合一":
          shrinkRatio = 4;
          break;
        case "六合一":
          shrinkRatio = 6;
          break;
        default:
          shrinkRatio = 1;
      }

      // 计算实际需要打印的张数（考虑双面打印、混合打印和缩印）
      this.calculatedPageCount = Math.ceil(totalPdfPages / shrinkRatio);
      let pagesNumber = 0;
      if (this.order.printSide === "双面" || this.order.printSide === "混合") {
        pagesNumber = Math.ceil(this.calculatedPageCount / 2);
      }

      // 检查装订方式的页数限制
      if (this.order.bindingMethod === "订书钉" && pagesNumber > 100) {
        this.$message.error("订书钉装订限制100张以内");
        return false;
      }

      if (this.order.bindingMethod === "骑马订") {
        if (pagesNumber < 2 || pagesNumber > 16) {
          this.$message.error("骑马订装订限制2-16张");
          return false;
        }
      }

      // 从价格表中查找对应的价格
      const sizeGroup = this.priceData.find(
        (group) => group.size === this.order.paperSize
      );
      if (!sizeGroup) {
        //this.$message.error("未找到对应的纸张尺寸价格配置");
        return false;
      }

      const matchedPrices = sizeGroup.prices.filter(
        (item) =>
          item.type === (this.order.printType === "black" ? "黑白" : "彩色") &&
          item.material === this.order.paperMaterial &&
          item.thickness === this.order.paperThickness
      );

      if (matchedPrices.length === 0) {
        this.$message.error("未找到对应的价格配置，请检查选项");
        return false;
      }

      // 根据页数选择正确的价格
      // 如果有多个匹配的价格，根据总页数（页数×份数）选择（零散类1-20P，批量类20P以上）
      let matchedPrice = matchedPrices[0];
      if (matchedPrices.length > 1) {
        // 按价格排序，价格高的在前面（零散类价格高）
        matchedPrices.sort((a, b) => b.singleSide - a.singleSide);

        // 总页数 = 计算页数 × 份数
        // 配送方式为校内自取时，不管页数多少都使用批量价格
        // 其他配送方式：20页以上使用批量价格（价格低的），20页及以下使用零散价格（价格高的）
        const totalPageCount = this.calculatedPageCount * this.order.copies;
        const isBulk =
          this.order.deliveryMethod === "校内自取" || totalPageCount > 20;
        matchedPrice = isBulk ? matchedPrices[1] : matchedPrices[0];
      }

      // 获取单价
      this.calculatedPrice.unitPrice =
        this.order.printSide === "单面"
          ? matchedPrice.singleSide
          : matchedPrice.doubleSide;

      if (this.calculatedPrice.unitPrice === null) {
        this.$message.error("当前打印方式暂不支持，请重新选择");
        return false;
      }

      // 计算基础打印费用（使用totalPdfPages，面为单位）
      let basePrintPrice =
        this.calculatedPrice.unitPrice * totalPdfPages * this.order.copies;

      // 计算封面价格
      this.coverPrice = 0;
      if (this.order.fm_content) {
        // 获取封面基础价格
        let singleCoverPrice = 0;
        if (this.order.fm_type.includes("皮纹纸")) {
          singleCoverPrice = 4;
        } else if (this.order.fm_type === "铜版纸-无膜") {
          singleCoverPrice = 6;
        } else {
          singleCoverPrice = 10;
        }

        // 根据封面内容类型计算价格

        if (this.order.fm_content === "空白") {
          // 空白封面：直接加封面价格
          this.coverPrice = singleCoverPrice * this.order.copies;
        } else if (this.order.fm_content === "首页") {
          // 首页为封面：加封面价格，减去一页内页价格
          this.coverPrice = singleCoverPrice * this.order.copies;
          this.calculatedPageCount--;
          basePrintPrice -= this.calculatedPrice.unitPrice * this.order.copies;
        } else if (this.order.fm_content === "首尾") {
          this.coverPrice = singleCoverPrice * this.order.copies;
          this.calculatedPageCount -= 2;
          basePrintPrice -=
            this.calculatedPrice.unitPrice * this.order.copies * 2;
        }
      }

      // 计算装订费用
      let bindingPrice = 0;
      if (this.order.bindingMethod === "骑马订") {
        bindingPrice = 2 * this.order.copies; // 每份2元
      } else if (this.order.bindingMethod === "胶装") {
        // 计算胶装费用：10元/份
        bindingPrice = 10 * this.order.copies;
      }
      this.calculatedPrice.bindingPrice = bindingPrice;

      // 计算基础总价（打印费用 + 装订费用 + 封面费用）
      this.calculatedPrice.basePrice =
        basePrintPrice + bindingPrice + this.coverPrice;

      let discountRate = 1;
      if (this.order.deliveryMethod === "校外自取") {
        discountRate = 0.7;
      } else {
        discountRate = 0.5;
      }

      this.calculatedPrice.discountAmount =
        this.calculatedPrice.basePrice * (1 - discountRate);

      this.calculatedPrice.totalPrice = Math.max(
        0,
        this.calculatedPrice.basePrice - this.calculatedPrice.discountAmount
      );

      if (this.userId == 6) {
        this.calculatedPrice.totalPrice = 0;
        return true;
      }

      const hasOrder = await this.checkHasOrders();
      if (this.order.deliveryMethod === "校内自取") {
        if (!hasOrder && this.useInnerCoupon) {
          const discount = 5;
          this.calculatedPrice.totalPrice = Math.max(
            0,
            this.calculatedPrice.totalPrice - discount
          );
        }
      } else {
        if (!hasOrder && this.useCoupon) {
          const discount = 5;
          this.calculatedPrice.totalPrice = Math.max(
            0,
            this.calculatedPrice.totalPrice - discount
          );
        }
      }

      //this.calculatedPrice.totalPrice = 0.01;

      return true;
    },

    // 添加重新计算价格的方法
    async recalculatePrice() {
      if (this.fileList.length > 0) {
        await this.calculatePrice();
      }
    },

    async checkHasOrders() {
      if (!this.userId) {
        return true;
      }
      try {
        const response = await fetch(
          `https://www.xiaoliangtongxue.cn/api/order/has-order?user_id=${this.userId}`,
          {
            method: "GET",
            credentials: "include",
          }
        );
        const result = await response.json();
        this.hasOrders = result.has_orders || false;
        this.hasInnerOrders = result.inner_has_orders || false;
        return result.has_orders || false;
      } catch (error) {
        console.error("检查订单失败:", error);
        return true;
      }
    },

    // 提交订单
    async submitOrder() {
      this.$refs.orderForm.validate(async (valid) => {
        if (valid) {
          if (this.fileList.length === 0) {
            this.$message.warning("请上传至少一个文件");
            return;
          }

          if (!this.order.printType) {
            this.$message.warning("请选择打印要求");
            return;
          }

          if (!this.order.printSide) {
            this.$message.warning("请选择打印面数");
            return;
          }

          if (!this.order.paperSize) {
            this.$message.warning("请选择纸张大小");
            return;
          }

          if (!this.order.paperMaterial) {
            this.$message.warning("请选择纸张材质");
            return;
          }

          if (!this.order.paperThickness) {
            this.$message.warning("请选择纸张厚度");
            return;
          }

          if (!this.order.bindingMethod) {
            this.$message.warning("请选择装订方式");
            return;
          }

          // 验证装订方式的页数限制
          if (!this.validateBindingMethod()) {
            return;
          }

          // 当打印面数为双面时，验证翻页方式
          if (this.order.printSide === "双面" && !this.order.method) {
            this.$message.warning("请选择翻页方式");
            return;
          }

          // 封面内容不为空时，需要验证封面类型和工艺
          if (this.order.fm_content) {
            if (!this.order.fm_type) {
              this.$message.warning("请选择封面类型");
              return;
            }
          }

          // 计算价格
          if (!(await this.calculatePrice())) {
            return;
          }

          // 验证配送信息
          if (!this.order.name) {
            this.$message.warning("请输入姓名");
            return;
          }

          if (!this.order.phone) {
            this.$message.warning("请输入手机号");
            return;
          }

          this.confirmDialogVisible = true;
          this.$nextTick(() => {
            this.generatePhysicalSheets();
            this.renderBookPreview();
          });
        } else {
          this.$message.error("请填写完整的订单信息！");
        }
      });
    },

    // 验证装订方式的页数限制
    validateBindingMethod() {
      // 获取所有文件的页数
      const filePages = Object.values(this.filePages);
      const totalPages = filePages.reduce((sum, pages) => sum + pages, 0);

      // 根据打印面数计算纸张张数
      let totalSheets = 0;
      if (this.order.printSide === "单面") {
        totalSheets = totalPages;
      } else if (this.order.printSide === "双面") {
        totalSheets = Math.ceil(totalPages / 2);
      } else if (this.order.printSide === "混合") {
        const singleSidePages = this.selectedSingleSidePages.length;
        const doubleSidePages = totalPages - singleSidePages;
        totalSheets = singleSidePages + Math.ceil(doubleSidePages / 2);
      }
      console.log(totalSheets);

      // 根据装订方式验证页数限制
      if (this.order.bindingMethod === "胶装") {
        // 胶装：20-200张
        if (totalSheets < 10 || totalSheets > 200) {
          this.$message.warning("页数不符合胶装工艺页数要求，请联系人工客服");
          return false;
        }
      } else if (this.order.bindingMethod === "骑马订") {
        // 骑马订：8-40张，且必须是4的倍数
        if (totalSheets < 8 || totalSheets > 40) {
          this.$message.warning("页数不符合骑马订工艺页数要求，请联系人工客服");
          return false;
        }
        if (totalSheets % 4 !== 0) {
          this.$message.warning("页数不符合骑马订工艺页数要求，请联系人工客服");
          return false;
        }
      } else if (this.order.bindingMethod === "订书钉") {
        // 订书钉：3-40张
        if (totalSheets < 3 || totalSheets > 40) {
          this.$message.warning("页数不符合订书钉工艺页数要求，请联系人工客服");
          return false;
        }
      }

      return true;
    },

    // 文件预览方法
    openFilePreview() {
      if (this.fileList.length === 0) {
        this.$message.warning("请先上传文件");
        return;
      }

      if (!this.order.printType) {
        this.$message.warning("请选择打印要求");
        return;
      }

      if (!this.order.printSide) {
        this.$message.warning("请选择打印面数");
        return;
      }

      if (!this.order.paperSize) {
        this.$message.warning("请选择纸张大小");
        return;
      }

      if (!this.order.paperMaterial) {
        this.$message.warning("请选择纸张材质");
        return;
      }

      if (!this.order.paperThickness) {
        this.$message.warning("请选择纸张厚度");
        return;
      }

      if (!this.order.bindingMethod) {
        this.$message.warning("请选择装订方式");
        return;
      }

      // 当打印面数为双面时，验证翻页方式
      if (this.order.printSide === "双面" && !this.order.method) {
        this.$message.warning("请选择翻页方式");
        return;
      }

      // 封面内容不为空时，需要验证封面类型和工艺
      if (this.order.fm_content) {
        if (!this.order.fm_type) {
          this.$message.warning("请选择封面类型");
          return;
        }

        // if (!this.order.fm_method) {
        //   this.$message.warning("请选择封面工艺");
        //   return;
        // }
      }

      this.generatePhysicalSheets();
      this.previewDialogVisible = true;
      this.$nextTick(() => {
        this.$nextTick(() => {
          this.renderBookPreview();
        });
      });
    },

    // 添加超出文件数量限制的处理方法
    handleExceed() {
      this.$message.warning("只能上传一个文件，请先删除已有文件");
    },

    async submit() {
      // 创建订单
      try {
        // 构造订单数据
        const orderData = {
          user_id: parseInt(this.userId),
          color: this.order.printType === "color",
          page: this.order.printSide,
          size: this.order.paperSize,
          material: this.order.paperMaterial,
          thick: this.order.paperThickness,
          copies: this.order.copies,
          phone: this.order.phone,
          address: this.order.deliveryAddress,
          price: this.calculatedPrice.basePrice,
          coupon_id: this.useInnerCoupon ? 2 : this.useCoupon ? 1 : null,
          binding: this.order.bindingMethod,
          method: this.order.method,
          fm_content: this.order.fm_content,
          fm_type: this.order.fm_content ? this.order.fm_type : null,
          fm_method: this.order.fm_content ? this.order.fm_method : null,
          suoyin: this.order.suoyin,
          pay: this.calculatedPrice.totalPrice,
          note: this.order.note,
          web: 1,
        };

        console.log("提交订单数据:", orderData);

        // 发送请求创建订单
        const response = await fetch(
          "https://www.xiaoliangtongxue.cn/api/order",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            credentials: "include",
            body: JSON.stringify(orderData),
          }
        );

        const result = await response.json();
        console.log("订单创建结果:", result);

        if (!result.success) {
          throw new Error(result.message || "创建订单失败");
        }

        // 获取订单ID
        const orderId = result.id;
        this.orderNumber = orderId;

        // 上传文件
        if (this.fileList.length === 1) {
          const file = this.fileList[0];
          const formData = new FormData();
          // 使用订单ID作为文件名
          const newFileName = `${orderId}.pdf`;
          formData.append("file", file.raw, newFileName);

          try {
            const uploadResponse = await fetch(
              "https://www.xiaoliangtongxue.cn/api/upload",
              {
                method: "POST",
                body: formData,
                credentials: "include",
              }
            );

            const uploadResult = await uploadResponse.json();
            if (!uploadResult.success) {
              // 如果文件上传失败，删除已创建的订单
              await fetch(
                `https://www.xiaoliangtongxue.cn/api/order/${orderId}`,
                {
                  method: "DELETE",
                  credentials: "include",
                }
              );
              throw new Error(uploadResult.message || "文件上传失败");
            }
          } catch (error) {
            console.error("文件上传失败:", error);
            this.$message.error(`文件上传失败: ${error.message}`);
            return;
          }
        } else {
          throw new Error("请上传一个文件");
        }

        // 如果订单金额为0，直接更新订单状态为打印中
        if (this.calculatedPrice.totalPrice === 0) {
          await fetch(`https://www.xiaoliangtongxue.cn/api/order/${orderId}`, {
            method: "PUT",
            headers: {
              "Content-Type": "application/json",
            },
            credentials: "include",
            body: JSON.stringify({
              state: "printing",
            }),
          });
          this.$message.success("订单提交成功！");
          this.confirmDialogVisible = false;
          this.resetForm();
          // 跳转到订单列表页面
          this.$router.push("/my-orders");
          return;
        }

        this.showPaymentQRCode(); // 显示支付二维码
      } catch (error) {
        console.error("创建订单失败:", error);
        // 显示具体的错误信息
        this.$message.error(error.message || "创建订单失败，请重试");
      }
    },

    // 修改确认订单方法
    confirmOrder() {
      if (!this.userId) {
        this.$message.error("请先登录");
        return;
      }
      if (!this.order.printType) {
        this.$message.warning("请选择打印要求");
        return;
      }
      if (!this.order.deliveryAddress) {
        this.$message.warning("请选择配送地址");
        return;
      }

      // 如果金额为0，直接提交订单并标记为支付成功
      if (this.calculatedPrice.totalPrice === 0) {
        this.on = false;
        this.submit();
        return;
      }

      // 添加确认提示框
      this.$confirm("请仔细核对打印需求，付款后将无法修改!", {
        confirmButtonText: "确认无误",
        cancelButtonText: "返回修改",
        type: "warning",
        customClass: "print-confirm-dialog",
      })
        .then(() => {
          // 用户点击"确定"
          this.on = false;
          this.submit();
        })
        .catch(() => {
          // 用户点击"取消"或关闭弹窗
          return;
        });
    },

    // 修改显示支付二维码的方法
    async showPaymentQRCode() {
      const orderId = `PRINT_${String(this.orderNumber).padStart(6, "0")}`;
      this.order_id = orderId;
      const order_amount = (this.calculatedPrice.totalPrice || 0).toFixed(2);
      console.log(orderId, order_amount);
      const payResponse = await fetch(
        `https://www.xiaoliangtongxue.cn/api/pay?order_no=${orderId}&amount=${order_amount}`,
        {
          method: "GET",
          credentials: "include",
        }
      );
      const payResult = await payResponse.json();
      this.confirmDialogVisible = false;
      if (!this.on) {
        //console.log(payResult.PromiseResult);

        this.paymentDialogVisible = true;
        this.qrCodeUrl = `https://image-charts.com/chart?chs=200x200&cht=qr&choe=UTF-8&chl=${payResult.qr_url}`;
        this.startPaymentTimer();
        this.startPaymentCheck();
      } else {
        return;
      }
    },

    // 开始支付倒计时
    startPaymentTimer() {
      let countdown = 15 * 60; // 15分钟支付时间
      this.paymentTimer = setInterval(() => {
        if (countdown > 0) {
          const minutes = Math.floor(countdown / 60);
          const seconds = countdown % 60;
          this.expireTime = `${minutes}:${seconds.toString().padStart(2, "0")}`;
          countdown--;
        } else {
          this.cancelPayment();
        }
      }, 1000);
    },

    // 开始检查支付状态
    startPaymentCheck() {
      this.paymentCheckInterval = setInterval(async () => {
        await this.checkPaymentStatus();
      }, 1000); // 每1秒检查一次
    },

    // 修改支付状态检查方法
    async checkPaymentStatus() {
      const orderId = this.order_id;
      const id = this.orderNumber;
      const response = await fetch(
        `https://www.xiaoliangtongxue.cn/api/pay/status/${orderId}`,
        {
          method: "GET",
          credentials: "include",
        }
      );
      const result = await response.json();
      if (result.status === "paid") {
        this.clearPaymentTimers();
        const response = await fetch(
          `https://www.xiaoliangtongxue.cn/api/order/${id}`,
          {
            method: "PUT",
            headers: {
              "Content-Type": "application/json",
            },
            credentials: "include",
            body: JSON.stringify({
              state: "printing",
            }),
          }
        );
        if (!response.ok) {
          throw new Error("更新订单状态失败");
        }
        this.$message.success("支付成功！");
        this.paymentDialogVisible = false;
        this.resetForm();
        // 跳转到订单列表页面
        this.$router.push("/my-orders");
      }
    },

    // 修改取消支付方法
    async cancelPayment() {
      this.clearPaymentTimers();
      this.paymentDialogVisible = false;
      this.$message.info("已取消支付，可在我的订单中继续支付（15分钟内）");
    },

    // 清除所有定时器
    clearPaymentTimers() {
      if (this.paymentTimer) {
        clearInterval(this.paymentTimer);
        this.paymentTimer = null;
      }
      if (this.paymentCheckInterval) {
        clearInterval(this.paymentCheckInterval);
        this.paymentCheckInterval = null;
      }
    },

    // 组件销毁时清理定时器
    beforeDestroy() {
      this.clearPaymentTimers();
    },
    // 添加重置表单方法
    resetForm() {
      // 重置订单数据
      this.order = {
        printType: "black",
        printSide: "单面",
        paperSize: "A4",
        paperMaterial: "普通纸",
        copies: 1,
        name: this.order.name, // 保留用户信息
        phone: this.order.phone,
        deliveryAddress: "",
        deliveryTime: "",
        selectedCoupon: null,
        bindingMethod: "无装订",
        method: "竖版左翻",
        fm_content: "", // 重置封面内容
        fm_type: "铜版纸", // 重置封面类型
        //fm_method: "无膜", // 重置封面工艺
        suoyin: "不缩印", // 重置缩印方式
        note: "",
      };

      // 重置文件列表
      this.fileList.forEach((file) => {
        if (file.url) {
          URL.revokeObjectURL(file.url);
        }
      });
      this.fileList = [];
      this.filePages = {};

      // 重置混合打印相关数据
      this.selectedFile = null;
      this.totalPages = 0;
      this.visiblePages = [];
      this.selectedSingleSidePages = [];
      this.mixedPrintProcessed = false;

      // 重置价格计算
      this.calculatedPrice = {
        unitPrice: 0,
        totalPrice: 0,
        basePrice: 0,
        discountAmount: 0, // 重置优惠金额
        bindingPrice: 0, // 重置装订费用
      };
      this.calculatedPageCount = 0;

      // 重置表单验证
      if (this.$refs.orderForm) {
        this.$refs.orderForm.resetFields();
      }
    },

    // 禁用48小时前的日期
    disabledDate(time) {
      const now = new Date();
      const minTime = now.getTime();
      const maxTime = now.getTime() + 48 * 60 * 60 * 1000; // 48小时后
      return time.getTime() < minTime || time.getTime() > maxTime;
    },
    // 禁用小时
    disabledHours() {
      const hours = [];
      const now = new Date();
      const selectedDate = this.order.deliveryTime
        ? new Date(this.order.deliveryTime)
        : null;

      if (selectedDate) {
        const isToday = selectedDate.toDateString() === now.toDateString();
        const isTomorrow =
          new Date(now.getTime() + 24 * 60 * 60 * 1000).toDateString() ===
          selectedDate.toDateString();

        if (isToday) {
          // 如果是今天，禁用当前时间之前的小时
          for (let i = 0; i < now.getHours(); i++) {
            hours.push(i);
          }
        }

        if (isTomorrow) {
          const tomorrowLimit = new Date(now.getTime() + 48 * 60 * 60 * 1000);
          if (selectedDate.getTime() > tomorrowLimit.getTime()) {
            // 如果超过48小时，禁用所有小时
            for (let i = 0; i < 24; i++) {
              hours.push(i);
            }
          }
        }
      }

      return hours;
    },
    // 禁用分钟
    disabledMinutes(hour) {
      const minutes = [];
      const now = new Date();
      const selectedDate = this.order.deliveryTime
        ? new Date(this.order.deliveryTime)
        : null;

      if (selectedDate) {
        const isToday = selectedDate.toDateString() === now.toDateString();
        const isTomorrow =
          new Date(now.getTime() + 24 * 60 * 60 * 1000).toDateString() ===
          selectedDate.toDateString();

        if (isToday && hour === now.getHours()) {
          // 如果是今天的当前小时，禁用当前时间之前的分钟
          for (let i = 0; i < now.getMinutes(); i++) {
            minutes.push(i);
          }
        }

        if (isTomorrow) {
          const tomorrowLimit = new Date(now.getTime() + 48 * 60 * 60 * 1000);
          if (selectedDate.getTime() > tomorrowLimit.getTime()) {
            // 如果超过48小时，禁用所有分钟
            for (let i = 0; i < 60; i++) {
              minutes.push(i);
            }
          }
        }
      }

      return minutes;
    },
    showMaterialPopover(material, event) {
      this.hoveredMaterial = material;
      this.popoverPosition = {
        x: event.clientX + 20, // 向右偏移20px
        y: event.clientY - 20, // 向上偏移20px
      };
      this.popoverVisible = true;
    },
    hideMaterialPopover() {
      this.popoverVisible = false;
    },
    // 在 methods 中添加以下方法
    async fetchHasOrders() {
      if (!this.userId) {
        return;
      }
      try {
        const response = await fetch(
          `https://www.xiaoliangtongxue.cn/api/order/has-order?user_id=${this.userId}`,
          {
            method: "GET",
            credentials: "include",
          }
        );
        const result = await response.json();
        this.hasOrders = result.has_orders || false;
        this.hasInnerOrders = result.inner_has_orders || false;
      } catch (error) {
        console.error("检查订单失败:", error);
      }
    },
    async fetchAvailableCoupons() {
      try {
        if (!this.userId) {
          console.log("未登录，跳过获取优惠券");
          return;
        }

        const response = await fetch(
          `https://www.xiaoliangtongxue.cn/api/coupon/available?user_id=${this.userId}`,
          {
            method: "GET",
            credentials: "include",
          }
        );
        const data = await response.json();
        console.log("获取到的优惠券:", data); // 添加日志

        if (Array.isArray(data)) {
          this.availableCoupons = data;
        } else {
          console.error("Invalid coupon data format:", data);
          this.$message.error("获取优惠券失败");
        }
      } catch (error) {
        console.error("获取优惠券失败:", error);
        this.$message.error("获取优惠券失败");
      }
    },

    getCouponLabel(coupon) {
      const typeText = coupon.type === "fixed" ? "满减券" : "折扣券";
      const valueText =
        coupon.type === "fixed"
          ? `减${coupon.value}元`
          : `${(coupon.value / 10).toFixed(1)}折`;
      const conditionText =
        coupon.min_amount > 0 ? `满${coupon.min_amount}可用` : "";
      return `${typeText} ${valueText} ${conditionText}`;
    },
    // 添加获取历史地址的方法
    async fetchHistoryAddresses() {
      try {
        if (!this.userId) {
          console.log("未登录，跳过获取历史地址");
          return;
        }

        const response = await fetch(
          `https://www.xiaoliangtongxue.cn/api/user/addresses?user_id=${this.userId}`,
          {
            method: "GET",
            credentials: "include",
          }
        );
        const result = await response.json();

        if (result.success) {
          this.historyAddresses = result.data;
        } else {
          console.error("获取历史地址失败:", result.message);
        }
      } catch (error) {
        console.error("获取历史地址失败:", error);
      }
    },

    // 新增工艺说明弹窗方法
    showCraftGuide() {
      this.craftGuideVisible = true;
    },
    handleCloseCraftGuide(done) {
      this.craftGuideVisible = false;
      done();
    },
    // 混合打印页面选择对话框方法
    openPageSelectorDialog() {
      if (this.fileList.length === 0) {
        this.$message.warning("请先上传PDF文件");
        return;
      }
      this.pageSelectorDialogVisible = true;
      this.$nextTick(() => {
        this.renderAllPageThumbnails();
      });
    },
    handleClosePageSelector() {
      this.pageSelectorDialogVisible = false;
    },
    async confirmPageSelection() {
      this.pageSelectorDialogVisible = false;
      await this.processMixedPrintWithBlankPages();
      this.physicalSheets = []; // 清空物理纸张数据，强制重新生成
      await this.renderBookPreview(); // 重新渲染翻书预览
      this.recalculatePrice();
      this.$message.success("已根据混合打印设置添加空白页");
    },

    // 翻书效果相关方法
    // 生成物理纸张数据
    generatePhysicalSheets() {
      const totalPages = Object.values(this.filePages).reduce(
        (sum, pages) => sum + pages,
        0
      );
      if (totalPages === 0) return;

      // 获取缩印倍数
      let nIn1 = 1;
      switch (this.order.suoyin) {
        case "二合一":
          nIn1 = 2;
          break;
        case "四合一":
          nIn1 = 4;
          break;
        case "六合一":
          nIn1 = 6;
          break;
        default:
          nIn1 = 1;
      }
      this.nIn1 = nIn1;

      // 判断是否横向（根据翻页方式）
      this.isLandscape =
        this.order.method && this.order.method.includes("横版");

      const sheets = [];
      let currentPageIndex = 1;

      // 封面处理
      if (this.order.fm_content) {
        sheets.push({
          pages: ["cover"],
          back: null,
          isCover: true,
          isSingleSide: true,
        });
      }

      // 生成内容纸张
      while (currentPageIndex <= totalPages) {
        const sheetPages = [];
        for (let i = 0; i < nIn1; i++) {
          if (currentPageIndex <= totalPages) {
            sheetPages.push(currentPageIndex);
            currentPageIndex++;
          }
        }

        // 判断是否为单面（混合打印模式下）
        let isSingle = false;
        if (this.order.printSide === "单面") {
          isSingle = true;
        } else if (this.order.printSide === "混合") {
          // 如果文件已经处理过（添加了空白页），则不再根据 selectedSingleSidePages 判断
          // 直接按照双面打印处理
          if (!this.mixedPrintProcessed) {
            // 检查当前纸张的页面是否在单面打印列表中
            isSingle = sheetPages.some((page) =>
              this.selectedSingleSidePages.includes(page)
            );
          }
        }

        const sheet = {
          pages: sheetPages,
          back: null,
          isSingleSide: isSingle,
        };

        if (isSingle) {
          sheet.back = "BLANK";
        } else if (this.order.printSide !== "单面") {
          // 双面打印，生成背面内容
          const backPages = [];
          for (let i = 0; i < nIn1; i++) {
            if (currentPageIndex <= totalPages) {
              backPages.push(currentPageIndex);
              currentPageIndex++;
            }
          }
          sheet.back = backPages.length > 0 ? backPages : null;
        }

        sheets.push(sheet);
      }

      this.physicalSheets = sheets;
      this.currentSheetIndex = this.order.fm_content ? -1 : 0; // 如果有封面从封面开始，否则从第一页开始
    },

    // 获取页面指示器文本
    getPageIndicator() {
      if (this.physicalSheets.length === 0) return "";
      if (this.currentSheetIndex === -1) return "封面";
      return `${this.currentSheetIndex + 1} / ${this.physicalSheets.length}`;
    },

    // 渲染翻书预览
    async renderBookPreview() {
      if (this.physicalSheets.length === 0) {
        this.generatePhysicalSheets();
      }
      await this.renderBookState();
    },

    // 渲染书籍状态
    async renderBookState() {
      const leftContent = this.$refs.leftContent;
      const rightContent = this.$refs.rightContent;
      const leftNum = this.$refs.leftNum;
      const rightNum = this.$refs.rightNum;
      const leftPage = this.$refs.leftPage;
      const rightPage = this.$refs.rightPage;

      if (!leftContent || !rightContent) return;

      // 重置样式
      leftPage.className = "page left-static";
      rightPage.className = "page right-dynamic";

      // 黑白模式
      if (this.order.printType === "black") {
        leftPage.classList.add("grayscale-mode");
        rightPage.classList.add("grayscale-mode");
      }

      if (this.currentSheetIndex === -1) {
        // 封面状态
        leftPage.classList.add("transparent-page");
        leftContent.innerHTML = "";
        leftNum.textContent = "";

        rightPage.classList.add("is-cover");
        if (this.order.fm_content) {
          rightContent.innerHTML = '<div class="cover-content">封面</div>';
          rightNum.textContent = "Cover";
        } else {
          const firstSheet = this.physicalSheets[0];
          if (firstSheet && firstSheet.pages) {
            await this.renderNIn1Content(rightContent, firstSheet.pages);
            rightNum.textContent = `P.${firstSheet.pages[0]}-${
              firstSheet.pages[firstSheet.pages.length - 1]
            }`;
          }
        }
      } else {
        // 普通页面状态
        const currentSheet = this.physicalSheets[this.currentSheetIndex];
        const prevSheet =
          this.currentSheetIndex > 0
            ? this.physicalSheets[this.currentSheetIndex - 1]
            : null;

        rightPage.classList.remove("is-cover");

        // 渲染左页（第n-1张纸的背面）
        if (prevSheet) {
          const prevSheetIndex = this.physicalSheets.indexOf(prevSheet) + 1;
          if (prevSheet.back === "BLANK") {
            leftPage.classList.add("is-blank");
            leftContent.innerHTML = '<div class="blank-badge">空白页</div>';
            leftNum.textContent = `p${prevSheetIndex}-2`;
          } else if (prevSheet.back) {
            await this.renderNIn1Content(leftContent, prevSheet.back);
            leftNum.textContent = `p${prevSheetIndex}-2`;
          } else {
            // 如果前一张纸没有背面，显示前一张纸的正面
            if (prevSheet.pages) {
              await this.renderNIn1Content(leftContent, prevSheet.pages);
              leftNum.textContent = `p${prevSheetIndex}-1`;
            } else {
              leftPage.classList.add("transparent-page");
              leftContent.innerHTML = "";
              leftNum.textContent = "";
            }
          }
        } else {
          // 第一页，左侧显示封面的背面（如果有封面）
          if (this.order.fm_content) {
            leftPage.classList.add("is-blank");
            leftContent.innerHTML = '<div class="blank-badge">空白页</div>';
            leftNum.textContent = "p0-2";
          } else {
            leftPage.classList.add("transparent-page");
            leftContent.innerHTML = "";
            leftNum.textContent = "";
          }
        }

        // 渲染右页（第n张纸的正面）
        if (currentSheet && currentSheet.pages) {
          await this.renderNIn1Content(rightContent, currentSheet.pages);
          const currentSheetIndex =
            this.physicalSheets.indexOf(currentSheet) + 1;
          rightNum.textContent = `p${currentSheetIndex}-1`;
        } else {
          rightPage.classList.add("transparent-page");
          rightContent.innerHTML = "";
          rightNum.textContent = "";
        }
      }
    },

    // 渲染N合1内容
    async renderNIn1Content(container, pageNumbers) {
      container.innerHTML = "";
      if (!pageNumbers || pageNumbers.length === 0) return;

      const file = this.fileList[0];
      if (!file || !this.pdfjsLib) return;

      if (this.nIn1 === 1) {
        // 正常模式
        await this.renderPdfPage(container, pageNumbers[0]);
      } else {
        // 缩印模式
        const gridDiv = document.createElement("div");
        gridDiv.className = "n-in-1-container";

        if (this.nIn1 === 2) {
          gridDiv.style.gridTemplateRows = "1fr 1fr";
          gridDiv.style.gridTemplateColumns = "1fr";
        } else if (this.nIn1 === 4) {
          gridDiv.style.gridTemplateRows = "1fr 1fr";
          gridDiv.style.gridTemplateColumns = "1fr 1fr";
        } else if (this.nIn1 === 6) {
          gridDiv.style.gridTemplateRows = "1fr 1fr 1fr";
          gridDiv.style.gridTemplateColumns = "1fr 1fr";
        }

        container.appendChild(gridDiv);

        for (const pageNum of pageNumbers) {
          const itemDiv = document.createElement("div");
          itemDiv.className = "n-in-1-item";
          gridDiv.appendChild(itemDiv);
          await this.renderPdfPage(itemDiv, pageNum);
        }
      }
    },

    // 渲染单个PDF页面
    async renderPdfPage(container, pageNum) {
      // 计算实际总页数，不依赖this.totalPages
      const totalPages = Object.values(this.filePages).reduce(
        (sum, pages) => sum + pages,
        0
      );
      if (!pageNum || pageNum > totalPages) return;

      const file = this.fileList[0];
      if (!file || !this.pdfjsLib) return;

      try {
        const reader = new FileReader();
        reader.onload = async (event) => {
          const typedarray = new Uint8Array(event.target.result);
          try {
            const pdf = await this.pdfjsLib.getDocument({ data: typedarray })
              .promise;
            const page = await pdf.getPage(pageNum);

            const containerWidth = container.clientWidth;
            const containerHeight = container.clientHeight;

            if (containerWidth === 0 || containerHeight === 0) return;

            const viewportRaw = page.getViewport({ scale: 1 });
            const scaleX = containerWidth / viewportRaw.width;
            const scaleY = containerHeight / viewportRaw.height;
            const scale = Math.max(scaleX, scaleY);

            const viewport = page.getViewport({ scale });
            const canvas = document.createElement("canvas");
            const context = canvas.getContext("2d");
            canvas.height = viewport.height;
            canvas.width = viewport.width;

            await page.render({ canvasContext: context, viewport }).promise;
            container.appendChild(canvas);
          } catch (err) {
            console.error("PDF 渲染错误:", err);
          }
        };
        reader.readAsArrayBuffer(file.raw);
      } catch (err) {
        console.error("PDF 渲染错误:", err);
      }
    },

    // 下一页
    async goNextPage() {
      if (
        this.isAnimating ||
        this.currentSheetIndex >= this.physicalSheets.length - 1
      )
        return;
      this.isAnimating = true;

      // 真正的翻书效果 - 右页向左翻转（翻到左边）
      const rightPage = this.$refs.rightPage;
      rightPage.style.transition = "transform 0.5s ease, opacity 0.5s ease";
      rightPage.style.transform = "rotateY(-90deg)";
      rightPage.style.opacity = "0";

      setTimeout(() => {
        this.currentSheetIndex++;
        this.renderBookState();

        const newRight = this.$refs.rightPage;
        newRight.style.transition = "none";
        newRight.style.transform = "rotateY(90deg)";

        setTimeout(() => {
          newRight.style.transition = "transform 0.5s ease, opacity 0.5s ease";
          newRight.style.transform = "rotateY(0deg)";
          newRight.style.opacity = "1";
          this.isAnimating = false;
        }, 50);
      }, 500);
    },

    // 上一页
    async goPrevPage() {
      if (this.isAnimating || this.currentSheetIndex <= -1) return;
      this.isAnimating = true;

      // 真正的翻书效果 - 左页向右翻转（翻到右边）
      const leftPage = this.$refs.leftPage;
      leftPage.style.transition = "transform 0.5s ease, opacity 0.5s ease";
      leftPage.style.transform = "rotateY(90deg)";
      leftPage.style.opacity = "0";

      setTimeout(() => {
        this.currentSheetIndex--;
        this.renderBookState();

        const newLeft = this.$refs.leftPage;
        newLeft.style.transition = "none";
        newLeft.style.transform = "rotateY(-90deg)";

        setTimeout(() => {
          newLeft.style.transition = "transform 0.5s ease, opacity 0.5s ease";
          newLeft.style.transform = "rotateY(0deg)";
          newLeft.style.opacity = "1";
          this.isAnimating = false;
        }, 50);
      }, 500);
    },

    // 处理混合打印文件，添加空白页
    async processMixedPrintWithBlankPages() {
      if (!this.fileList || this.fileList.length === 0) {
        return;
      }

      const file = this.fileList[0];
      try {
        // 加载pdf-lib库
        if (!window.PDFLib) {
          // 动态加载pdf-lib
          await new Promise((resolve, reject) => {
            const script = document.createElement("script");
            script.src = "https://unpkg.com/pdf-lib@1.17.1/dist/pdf-lib.js";
            script.onload = resolve;
            script.onerror = reject;
            document.head.appendChild(script);
          });
        }

        const { PDFDocument } = window.PDFLib;

        // 获取原始PDF
        const reader = new FileReader();
        const originalPdfBytes = await new Promise((resolve) => {
          reader.onload = (e) => resolve(new Uint8Array(e.target.result));
          reader.readAsArrayBuffer(file.raw);
        });
        const originalPdf = await PDFDocument.load(originalPdfBytes);

        // 创建新的PDF文档
        const pdfDoc = await PDFDocument.create();

        // 复制原始PDF的所有页面
        const copiedPages = await pdfDoc.copyPages(
          originalPdf,
          originalPdf.getPageIndices()
        );

        // 按照用户选择的单面打印页面添加空白页
        const selectedPages = this.selectedSingleSidePages.sort(
          (a, b) => a - b
        );
        let currentPageNum = 0; // 当前实际页码（考虑了已添加的空白页）

        for (let i = 0; i < copiedPages.length; i++) {
          const originalPageNum = i + 1; // 原始页码

          // 检查当前页是否被选择为单面打印
          const isSingleSide = selectedPages.includes(originalPageNum);

          // 如果当前实际页码是偶数（意味着这页会打印在纸张背面）
          // 而用户选择这页为单面打印，则需要先添加一个空白页
          // 让这页从纸张正面开始
          if (isSingleSide && currentPageNum % 2 === 1) {
            const { width, height } = copiedPages[i].getSize();
            pdfDoc.addPage([width, height]);
            currentPageNum++;
          }

          // 添加当前页面
          pdfDoc.addPage(copiedPages[i]);
          currentPageNum++;

          // 如果这是单面打印页面，在其后再添加一个空白页
          if (isSingleSide) {
            const { width, height } = copiedPages[i].getSize();
            pdfDoc.addPage([width, height]);
            currentPageNum++;
          }
        }

        // 生成PDF字节
        const pdfBytes = await pdfDoc.save();

        // 创建新的文件对象
        const blob = new Blob([pdfBytes], { type: "application/pdf" });
        const newFile = new File([blob], file.name, {
          type: "application/pdf",
          lastModified: Date.now(),
        });

        // 更新文件列表中的文件
        const newFileObj = {
          uid: file.uid,
          name: file.name,
          raw: newFile,
          status: "success",
          url: URL.createObjectURL(blob),
        };

        // 更新文件列表
        this.fileList = [newFileObj];
        this.selectedFile = newFileObj;

        // 更新页数
        const newPageCount = await this.getPdfPageCount(newFileObj);
        this.filePages[file.uid] = newPageCount;
        this.totalPages = newPageCount;

        // 更新可见页面数组（用于页面选择器）
        this.visiblePages = Array.from(
          { length: newPageCount },
          (_, i) => i + 1
        );

        // 标记混合打印文件已处理
        this.mixedPrintProcessed = true;

        // 重新渲染预览
        await this.createPdfPreview(newFileObj);
      } catch (error) {
        console.error("处理混合打印文件失败:", error);
        this.$message.error("处理混合打印文件失败，请重试");
      }
    },
  },
};
</script>
  
<style scoped>
.order-form-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 10px;
  min-height: 100vh;
}

.full-height {
  display: flex;
  flex-direction: column;
  justify-content: flex-start; /* 改为从顶部开始 */
}

.form-and-price {
  display: flex;
  gap: 40px;
}

.order-form {
  margin: 0 auto;
  flex: 1;
  max-width: 600px;
  background: white;
  border-radius: 12px;
  transition: transform 0.3s ease;
}

.header {
  text-align: center;
  margin-bottom: 30px;
}

.header h1 {
  color: #2d3748;
  font-size: 28px;
  font-weight: 600;
  margin: 0;
}

.el-main {
  padding: 10px;
  background-color: transparent;
}

.el-upload__tip {
  color: #718096;
}

.upload-container {
  width: 100%;
  display: flex;
  justify-content: center;
  margin-top: 20vh;
}

.upload-demo {
  width: 100%;
}

.upload-demo :deep(.el-upload-dragger) {
  width: 100%;
  height: 200px;
  border: 2px dashed #858585;
  border-radius: 12px;
  transition: all 0.3s ease;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 20px;
}

.upload-demo :deep(.el-upload-dragger:hover) {
  border-color: #020202;
  transform: translateY(-2px);
  box-shadow: 0 8px 24px rgba(64, 158, 255, 0.15);
}

.upload-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  text-align: center;
}

.upload-icon {
  width: 50px;
  height: 50px;
  object-fit: contain;
  margin-bottom: 12px;
  transition: transform 0.3s ease;
}

.upload-demo:hover .upload-icon {
  transform: scale(1.1);
}

.upload-text {
  font-size: 16px;
  color: grey;
  font-weight: 500;
}

.upload-demo :deep(.el-upload__tip) {
  font-size: 14px;
  color: #909399;
}

.file-name-text {
  font-size: 14px;
  color: #2d3748;
  font-weight: 500;
  word-break: break-all;
}

.section-header {
  text-align: center;
  margin: 0 0 20px 0;
  padding: 10px 0;
}

.section-header h2 {
  color: #2d3748;
  margin: 0;
}

.confirm-dialog-content {
  display: flex;
  flex-direction: row;
  gap: 20px;
  padding: 20px;
}

.confirm-dialog-content :deep(.el-descriptions) {
  border-radius: 12px;
  overflow: hidden;
}

.confirm-dialog-content :deep(.el-descriptions__header) {
  background-color: #f9fafb;
}

.confirm-dialog-content :deep(.el-descriptions__body) {
  background-color: #ffffff;
}

.confirm-dialog-content :deep(.el-descriptions__label) {
  background-color: #f9fafb;
  color: #2d3748;
  font-weight: 500;
  white-space: nowrap;
}

.confirm-dialog-content :deep(.el-descriptions__content) {
  color: #2d3748;
}

.confirm-dialog-content :deep(.el-form-item__label) {
  font-weight: 500;
  color: #2d3748;
}

.confirm-dialog-content :deep(.el-input__wrapper) {
  border-radius: 8px;
  border: 1.5px solid #e5e7eb;
  box-shadow: none;
  transition: all 0.3s ease;
}

.confirm-dialog-content :deep(.el-input__wrapper:hover) {
  border-color: #000000;
}

.confirm-dialog-content :deep(.el-input__wrapper.is-focus) {
  border-color: #000000;
  box-shadow: 0 0 0 2px rgba(0, 0, 0, 0.1);
}

.confirm-dialog-content :deep(.el-textarea__inner) {
  border-radius: 8px;
  border: 1.5px solid #000000;
  box-shadow: none;
  transition: all 0.3s ease;
  background-color: #ffffff;
}

.confirm-dialog-content :deep(.el-textarea__inner:hover) {
  border-color: #000000;
}

.confirm-dialog-content :deep(.el-textarea__inner:focus) {
  border-color: #000000;
  box-shadow: 0 0 0 2px rgba(0, 0, 0, 0.1);
}

.confirm-dialog-content :deep(.el-textarea .el-input__wrapper) {
  border-radius: 8px;
  border: 1.5px solid #e5e7eb;
  box-shadow: none;
  transition: all 0.3s ease;
  background-color: #ffffff;
  padding: 8px 12px;
}

.confirm-dialog-content :deep(.el-textarea .el-input__wrapper:hover) {
  border-color: #000000;
}

.confirm-dialog-content :deep(.el-textarea .el-input__wrapper.is-focus) {
  border-color: #000000;
  box-shadow: 0 0 0 2px rgba(0, 0, 0, 0.1);
}

.confirm-dialog-content :deep(.el-radio-group) {
  display: flex;
  gap: 20px;
}

.confirm-dialog-content :deep(.el-radio) {
  margin-right: 0;
}

.confirm-dialog-content :deep(.el-radio__label) {
  color: #2d3748;
  font-weight: 500;
}

.confirm-dialog-content :deep(.el-radio__input.is-checked + .el-radio__label) {
  color: #000000;
  font-weight: 600;
}

.confirm-dialog-content :deep(.el-radio__input.is-checked .el-radio__inner) {
  border-color: #000000;
  background-color: #000000;
}

.confirm-dialog-content
  :deep(.el-radio__input.is-checked .el-radio__inner::after) {
  background-color: #ffffff;
}

.confirm-dialog-content :deep(.el-radio:hover .el-radio__inner) {
  border-color: #000000;
}

.confirm-dialog-content :deep(.el-select .el-input__wrapper) {
  border-radius: 8px;
  border: 1.5px solid #e5e7eb;
  box-shadow: none;
  transition: all 0.3s ease;
}

.confirm-dialog-content :deep(.el-select .el-input__wrapper:hover) {
  border-color: #000000;
}

.confirm-dialog-content :deep(.el-select .el-input__wrapper.is-focus) {
  border-color: #000000;
  box-shadow: 0 0 0 2px rgba(0, 0, 0, 0.1);
}

.confirm-dialog-content + .el-dialog__footer {
  padding: 20px;
  border-top: 1px solid #e5e7eb;
}

.confirm-dialog-content + .el-dialog__footer .el-button {
  background-color: white;
  color: black;
  border: 1px solid black;
  padding: 12px 24px;
  font-weight: 500;
  transition: all 0.3s ease;
  border-radius: 8px;
}

.confirm-dialog-content + .el-dialog__footer .el-button:hover {
  background-color: black;
  color: #fff;
  border-color: black;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
}

.confirm-dialog-content + .el-dialog__footer .el-button--warning {
  background-color: white;
  color: #f59e0b;
  border: 1px solid #f59e0b;
}

.confirm-dialog-content + .el-dialog__footer .el-button--warning:hover {
  background-color: #f59e0b;
  color: white;
  border-color: #f59e0b;
}

.confirm-dialog-content + .el-dialog__footer .el-button--primary {
  background-color: black;
  color: white;
  border: 1px solid black;
}

.confirm-dialog-content + .el-dialog__footer .el-button--primary:hover {
  background-color: #333333;
  border-color: #333333;
}

:deep(.el-dialog) {
  border-radius: 16px;
  overflow: hidden;
}

:deep(.el-dialog__header) {
  padding: 24px 24px 16px 24px;
  border-bottom: 1px solid #e5e7eb;
}

:deep(.el-dialog__title) {
  color: #000000;
  font-size: 18px;
  font-weight: 600;
}

:deep(.el-dialog__body) {
  padding: 0;
}

.left-panel {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 20px;
  min-width: 0;
}

.right-panel {
  flex: 1;
  min-width: 0;
  padding: 20px;
  background-color: #ffffff;
  border-radius: 12px;
  border: 1.5px solid #000000;
  display: flex;
  flex-direction: column;
}

.right-panel h3 {
  margin: 0 0 15px 40%;
  color: #2d3748;
  font-size: 16px;
  font-weight: 600;
}

.right-panel-buttons {
  display: flex;
  justify-content: space-evenly;
  gap: 10px;
  margin-top: auto;
  padding-top: 20px;
}

.right-panel :deep(.el-descriptions) {
  flex-shrink: 0;
}

.order-details {
  width: 100%;
  padding: 20px;
}

.delivery-info {
  padding: 20px;
  background-color: #ffffff;
  border-radius: 12px;
  border: 1.5px solid #000000;
}

.delivery-info h3 {
  margin: 0 0 15px 0;
  color: #2d3748;
  font-size: 16px;
  font-weight: 600;
}

.file-preview {
  max-height: 800px;
  overflow-y: auto;
  padding-right: 10px;
}

.file-preview::-webkit-scrollbar {
  width: 6px;
}

.file-preview::-webkit-scrollbar-thumb {
  background-color: #cbd5e0;
  border-radius: 3px;
}

.file-item {
  height: 400px;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px;
  margin-bottom: 15px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  background: #f8fafc;
  transition: all 0.3s ease;
}

.file-item:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
}

.file-info {
  margin: 15px 0;
  text-align: center;
}

.file-info p {
  margin: 8px 0;
  color: #4a5568;
}

.no-file {
  text-align: center;
  padding: 40px;
  color: #718096;
  background: #f8fafc;
  border-radius: 8px;
  border: 2px dashed #e2e8f0;
}

.price-calculation {
  background-color: #ffffff;
  padding: 20px;
  border-radius: 12px;
  border: 1.5px solid #000000;
}

.price-calculation h3 {
  margin: 0 0 15px 0;
  color: #2d3748;
  font-size: 16px;
  font-weight: 600;
}

.price-details {
  display: flex;
  flex-direction: column;
}

.price-item {
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
  color: #2d3748;
}

.calculation-formula {
  font-size: 13px;
  color: #909399;
}

.price-divider {
  border-top: 1px dashed #000000;
  margin: 10px 0;
}

.price-total {
  font-size: 16px;
  font-weight: bold;
  color: #000000;
}

/* 添加优惠券相关样式 */
.coupon-option {
  display: flex;
  align-items: center;
  gap: 10px;
}

.coupon-type {
  background-color: #409eff;
  color: white;
  padding: 2px 6px;
  border-radius: 4px;
  font-size: 12px;
}

.coupon-value {
  color: #f56c6c;
  font-weight: bold;
}

.coupon-condition {
  color: #909399;
  font-size: 12px;
}

.discount-amount {
  color: #67c23a;
  font-weight: bold;
}

/* 自定义 Element UI 组件样式 */
:deep(.el-button) {
  background-color: white;
  color: black;
  border: 1px solid black;
  padding: 12px 24px;
  font-weight: 500;
  transition: all 0.3s ease;
}

:deep(.el-button:hover) {
  background-color: black;
  color: #fff;
  border-color: black;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
}

:deep(.el-form-item__label) {
  font-weight: 500;
  color: #2d3748;
}

:deep(.el-input__inner) {
  border-radius: 6px;
  border: 1.5px solid #000;
  transition: all 0.3s ease;
  box-shadow: none;
  padding-left: 5px;
}

:deep(.el-input__wrapper) {
  box-shadow: none !important;
  border: none !important;
}

:deep(.el-input__wrapper:focus-within) {
  box-shadow: none !important;
  border: none !important;
}

:deep(.el-input__inner:focus) {
  border-color: #000;
  box-shadow: 0 0 0 2px rgba(0, 0, 0, 0.1);
}

:deep(.el-radio__label) {
  color: #4a5568;
}

:deep(.el-select .el-input__inner) {
  height: 40px;
  border-color: #000;
}

:deep(.el-upload-dragger) {
  border-radius: 8px;
  border: 2px dashed #e2e8f0;
  transition: all 0.3s ease;
}

:deep(.el-upload-dragger:hover) {
  border-color: #409eff;
  background-color: #f8fafc;
}

.form-buttons {
  display: flex;
  justify-content: space-around;
  gap: 50px;
  margin-top: 30px;
  margin-left: 12vw;
}

:deep(.el-input-number) {
  box-shadow: none !important;
  border: none !important;
}

:deep(.el-input-number__decrease),
:deep(.el-input-number__increase) {
  border-color: #000;
  background-color: #909399;
  color: #fff;
}

:deep(.el-input-number__decrease:hover),
:deep(.el-input-number__increase:hover) {
  border-color: #000;
  background-color: #909399;
  color: #fff;
}

.paper-samples {
  margin-bottom: 40px;
  background: white;
  padding: 30px;
  border-radius: 12px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
}

.paper-samples h2 {
  text-align: center;
  margin-bottom: 30px;
  color: #409eff;
  font-size: 24px;
  font-weight: 600;
}

.sample-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 20px;
}

.sample-card {
  transition: transform 0.3s ease;
}

.sample-card:hover {
  transform: translateY(-5px);
}

.sample-image {
  width: 100%;
  height: 200px;
  object-fit: cover;
  border-radius: 4px 4px 0 0;
}

.sample-info {
  padding: 15px;
}

.sample-info h3 {
  margin-top: 0;
  color: #2d3748;
  font-size: 18px;
}

.sample-info p {
  color: #718096;
  font-size: 14px;
  margin-bottom: 0;
}

.material-popover {
  position: fixed;
  z-index: 9999; /* 增加这个值，确保高于el-select的z-index */
  width: 300px;
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  padding: 15px;
  transform: translate(20px, -50%);
  pointer-events: none;
}

.popover-image {
  width: 100%;
  height: 300px;
  object-fit: contain; /* 不裁剪，完整显示 */
  border-radius: 4px;
  margin-bottom: 10px;
}

.popover-content h3 {
  margin: 0 0 8px 0;
  color: #2d3748;
  font-size: 18px;
}

.popover-content p {
  margin: 0;
  color: #718096;
  font-size: 14px;
}

.binding-option {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 10px 0;
}

.binding-name {
  font-weight: bold;
  color: #303133;
  margin-bottom: 5px;
}

.binding-price {
  color: #f56c6c;
  font-weight: bold;
  margin-bottom: 5px;
}

.binding-description {
  font-size: 12px;
  color: #909399;
  line-height: 1.4;
}

.binding-pages {
  margin-top: 5px;
}

.payment-dialog-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px;
}

.order-info {
  text-align: center;
  margin-bottom: 20px;
}

.order-number {
  font-size: 16px;
  color: #606266;
  margin-bottom: 10px;
}

.order-amount {
  font-size: 20px;
  color: #f56c6c;
  font-weight: bold;
}

.qr-code-container {
  width: 200px;
  height: 200px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 20px 0;
  background: #f8f9fa;
  border-radius: 8px;
}

.qr-code-image {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.qr-code-loading {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  color: #909399;
}

.payment-tips {
  text-align: center;
  color: #606266;
}

.payment-tips p {
  margin: 5px 0;
}

.expire-time {
  color: #f56c6c;
  font-weight: bold;
}

.coupon-section {
  margin: 20px 0;
  padding: 20px;
  background: #f8f9fa;
  border-radius: 8px;
}

.address-input-group {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.address-option {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.address-text {
  color: #2d3748;
}

.address-time {
  font-size: 12px;
  color: #6b7280;
}

/* 新增样式 */
.order-assistant {
  margin-bottom: 20px;
  padding: 20px;
  background: #f8f9fa;
  border-radius: 8px;
  border: 1px solid #e2e8f0;
}

.assistant-buttons {
  display: flex;
  gap: 15px;
  justify-content: center;
  margin-top: 20px;
}

.image-guide-content {
  display: flex;
  justify-content: center;
}

.image-container {
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #f0f2f5;
  border-radius: 8px;
  overflow: hidden;
}

.guide-image {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
}

.image-description {
  position: absolute;
  bottom: 10px;
  left: 50%;
  transform: translateX(-50%);
  background-color: rgba(0, 0, 0, 0.6);
  color: white;
  padding: 5px 10px;
  border-radius: 5px;
  font-size: 14px;
  white-space: nowrap;
  z-index: 10;
}

.craft-guide-content {
  padding: 10px;
  max-height: 70vh;
  overflow-y: auto;
}

.craft-guide-content::-webkit-scrollbar {
  width: 6px;
}

.craft-guide-content::-webkit-scrollbar-thumb {
  background-color: #dcdfe6;
  border-radius: 3px;
}

.craft-section {
  background: #ffffff;
  border-radius: 8px;
  padding: 24px;
  margin-bottom: 30px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.04);
}

.craft-section h3 {
  color: #409eff;
  font-size: 22px;
  font-weight: 600;
  margin-bottom: 24px;
  padding-bottom: 12px;
  border-bottom: 2px solid #ebeef5;
}

.craft-item {
  display: flex;
  align-items: center;
  gap: 24px;
  padding: 16px;
  margin-bottom: 16px;
  background: #f8f9fa;
  border-radius: 8px;
  transition: all 0.3s ease;
}

.craft-item:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
}

.craft-text {
  flex: 1;
}

.craft-text h4 {
  color: #303133;
  font-size: 18px;
  font-weight: 600;
  margin: 0 0 8px 0;
}

.craft-text p {
  color: #606266;
  font-size: 14px;
  line-height: 1.6;
  margin: 0;
}

.craft-image {
  width: 160px;
  height: 160px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #ffffff;
  border-radius: 8px;
  padding: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

.craft-image img {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
  border-radius: 4px;
}

/* 其他工艺说明部分的样式优化 */
.craft-section:last-child {
  margin-bottom: 0;
}

/* 缩印方式部分的样式调整 */
.craft-section img {
  display: block;
  margin: 16px 0;
  border-radius: 4px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

/* 订单确认对话框样式 */
.print-confirm-dialog .el-dialog__body {
  display: flex;
  justify-content: center;
  align-items: flex-start;
}

.print-confirm-dialog .confirm-dialog-content {
  width: 100%;
  max-width: 800px;
}

/* 文件预览对话框样式 */
.print-confirm-dialog .preview-section {
  width: 100%;
}

.print-confirm-dialog .book-preview-container {
  width: 100%;
  max-width: 800px;
  margin: 0 auto;
}

/* 添加确认框样式 */
:deep(.print-confirm-dialog .el-message-box__content) {
  padding: 20px;
  white-space: pre-line;
  line-height: 1.8;
  font-size: 15px;
}

:deep(.print-confirm-dialog .el-message-box__container) {
  position: relative;
}

:deep(.print-confirm-dialog .el-message-box__status) {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  font-size: 24px !important;
}

:deep(.print-confirm-dialog .el-message-box__message) {
  margin-left: 40px;
  color: #303133;
}

:deep(.print-confirm-dialog .el-message-box__btns) {
  padding: 12px 20px 5px;
}

:deep(.print-confirm-dialog .el-button--primary) {
  background-color: #67c23a;
  border-color: #67c23a;
}

:deep(.print-confirm-dialog .el-button--primary:hover),
:deep(.print-confirm-dialog .el-button--primary:focus) {
  background-color: #85ce61;
  border-color: #85ce61;
}

/* 新增样式 */
.announcement-bar {
  width: 100%;
  background-color: #fff;
  padding: 0;
  margin-bottom: 15px;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  display: flex;
  justify-content: center;
  align-items: center;
  height: 32px;
  overflow: hidden;
}

.scrolling-text {
  width: 100%;
  max-width: 1200px;
  margin: 0;
  padding: 0;
}

.scrolling-text :deep(.el-alert) {
  padding: 0;
  margin: 0;
  border-radius: 8px;
  height: 32px;
  line-height: 32px;
}

.scrolling-text :deep(.el-alert__title) {
  white-space: nowrap;
  animation: scroll 10s linear infinite;
  display: inline-block;
  padding-left: 100%;
  line-height: 32px;
  font-size: 13px;
}

.scrolling-text :deep(.el-alert__icon) {
  line-height: 32px;
  margin-right: 8px;
  font-size: 16px;
}

@keyframes scroll {
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(-100%);
  }
}

.binding-price-table {
  margin-top: 30px;
  background: #f8f9fa;
  padding: 20px;
  border-radius: 8px;
}

.binding-price-table h3 {
  color: #409eff;
  font-size: 18px;
  font-weight: 600;
  margin: 0 0 15px 0;
  padding-left: 10px;
  border-left: 4px solid #409eff;
}

.binding-price-table :deep(.el-table) {
  margin-top: 15px;
  border-radius: 8px;
  overflow: hidden;
}

.binding-price-table :deep(.el-table th) {
  background-color: #f5f7fa;
  color: #606266;
  font-weight: 600;
}

.binding-price-table :deep(.el-table td) {
  color: #606266;
}

@keyframes scroll {
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(-100%);
  }
}

.image-preview-wrapper {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 2000;
}

.preview-image {
  max-width: 80%;
  max-height: 80%;
  cursor: pointer;
}

.close-btn {
  position: absolute;
  top: 20px;
  right: 20px;
  width: 40px;
  height: 40px;
  font-size: 30px;
  color: white;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: all 0.3s;
}

.close-btn:hover {
  color: #ff4d4f;
  transform: scale(1.2);
}

/* 混合打印页面选择器样式 */
.page-selector-container {
  background: #f8f9fa;
  padding: 20px;
  border-radius: 8px;
  border: 1px solid #e2e8f0;
}

.page-selector-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
  padding-bottom: 10px;
  border-bottom: 1px solid #e2e8f0;
}

.page-selector-header span {
  color: #606266;
  font-size: 14px;
}

.page-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(120px, 1fr));
  gap: 10px;
  max-height: 400px;
  overflow-y: auto;
  padding-right: 5px;
}

.page-card {
  background: white;
  border-radius: 6px;
  padding: 8px;
  cursor: pointer;
  transition: all 0.2s;
  border: 2px solid transparent;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);
}

.page-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.12);
}

.page-card.selected {
  border-color: #409eff;
  background-color: #f0f9ff;
}

.page-selector-number {
  font-size: 14px;
  font-weight: 600;
  color: #303133;
  margin-bottom: 8px;
  text-align: center;
}

.page-thumb {
  width: 100%;
  height: 140px;
  background: #f5f7fa;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}

.page-thumb canvas {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
}

.page-selector-footer {
  margin-top: 15px;
  padding-top: 10px;
  border-top: 1px solid #e2e8f0;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.page-selector-footer span {
  color: #606266;
  font-size: 14px;
}

.page-selector-footer span:first-child {
  color: #67c23a;
  font-weight: 500;
}

:deep(.el-form-item__label) {
  font-size: 14px;
}

:deep(.page-selector-container) {
  max-height: 60vh;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

:deep(.page-selector-header) {
  flex-shrink: 0;
}

:deep(.page-grid) {
  flex: 1;
  overflow-y: auto;
  padding-right: 10px;
  max-height: 50vh;
}

:deep(.page-selector-footer) {
  flex-shrink: 0;
  border-top: 1px solid #e2e8f0;
  margin-top: 15px;
  padding-top: 10px;
}

.no-pages-message {
  text-align: center;
  padding: 40px;
  color: #606266;
}

.page-selector-actions {
  display: flex;
  gap: 10px;
}

/* 翻书效果样式 */
.book-preview-section {
  min-width: 400px;
  display: flex;
  flex-direction: column;
}

.book-preview-container {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: #f5f7fa;
  border-radius: 8px;
  min-height: 500px;
}

.book-stage {
  width: 600px;
  height: 400px;
  perspective: 1500px;
  position: relative;
  margin: 0 auto 20px;
}

.book {
  width: 100%;
  height: 100%;
  position: relative;
  transform-style: preserve-3d;
}

.page {
  position: absolute;
  width: 50%;
  height: 100%;
  top: 0;
  background-color: #ffffff;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  backface-visibility: hidden;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.page.left-static {
  left: 0;
  transform-origin: right center;
  z-index: 1;
  border-radius: 4px 0 0 4px;
}

.page.right-dynamic {
  right: 0;
  transform-origin: left center;
  z-index: 2;
  border-radius: 0 4px 4px 0;
}

.page.grayscale-mode {
  filter: grayscale(100%) contrast(1.1);
}

.page.transparent-page {
  background: transparent !important;
  box-shadow: none !important;
  pointer-events: none;
}

.page.is-blank {
  background-color: #fafafa !important;
}

.page.is-cover {
  background: linear-gradient(135deg, #2d3748 0%, #4a5568 100%) !important;
  color: white;
}

.page-content {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
}

.page-content canvas {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
}

.page-number {
  position: absolute;
  bottom: 8px;
  font-size: 11px;
  color: #94a3b8;
  font-weight: bold;
  background: rgba(255, 255, 255, 0.9);
  padding: 2px 6px;
  border-radius: 4px;
}

.page-number.left-num {
  left: 8px;
}

.page-number.right-num {
  right: 8px;
}

.cover-content {
  font-size: 24px;
  font-weight: bold;
  color: white;
}

.blank-badge {
  border: 2px dashed #cbd5e0;
  padding: 20px 40px;
  border-radius: 8px;
  color: #718096;
  font-style: italic;
  background: rgba(255, 255, 255, 0.95);
  text-align: center;
  font-weight: bold;
}

.n-in-1-container {
  width: 100%;
  height: 100%;
  display: grid;
  gap: 2px;
  background: #fff;
  padding: 4px;
  box-sizing: border-box;
}

.n-in-1-item {
  position: relative;
  background: #fff;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
}

.n-in-1-item canvas {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
}

.book-controls {
  display: flex;
  align-items: center;
  gap: 15px;
  margin-top: 10px;
}

.page-indicator {
  font-size: 14px;
  font-weight: 600;
  color: #4a5568;
  min-width: 80px;
  text-align: center;
}

/* 横向模式 */
.book-stage.landscape {
  width: 700px;
  height: 250px;
  margin: 0 auto 20px;
}

:deep(.el-select__wrapper) {
  box-shadow: 0 0 0 1px #000 inset !important;
}

/* 下拉框选中效果 - 黑色加粗 */
:global(.el-select-dropdown__item.is-selected) {
  color: #000 !important;
  font-weight: bold !important;
}

:global(.el-select-dropdown__item.hover) {
  background-color: #f5f5f5 !important;
}
</style>
